/**
 * 사업자몰 통합검색
 *
 * DIT 2.0
 *  - 같은 폴더 search_all-VIO23.js 기반으로 작성
 *
 * @since 2023.10.23
 */
if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

(function () {
  //자동완성
  var autoCompleteItemTemplate =
    '<li><a href="#{{input}}">{{#raw text}}</a><button class="keyword_select"  data-contents="{{input}}" >검색어선택</button></li>';
  //자동완성 상품리스트  
  var autoCompletePrductListTemplate = 
	'<li>' + 
	'<a href="{{modelUrlPath}}" >' + 
	'    <span class="prod-img"><img src="{{_imageUrl}}" onError="lgkorUI.addImgCateErrorEvent(this, \'{{noImageUrl}}\' );" alt="{{modelName}}"></span>' + 
	'    <div class="model-info">' + 
	'        <p class="model-name">{{#raw _modelName}}</p> <!-- 검색어와 일치한 단어의 srch-word 추가 -->' + 
	'        <div class="prod-path">' + 
	'            <span>{{superCategoryName}}</span>' + 
	'            <span>{{categoryName}}</span>' + 
	'        </div>' + 
	'    </div>' + 
	'    <span class="txt-direct">제품 바로가기</span>' + 
	'</a>' + 
	'</li>'; 

  //최근검색어
  var recentItemTemplate =
    '<li><span class="box"><a href="#{{text}}">{{text}}</a><button type="button" class="btn-delete" title="검색어 삭제"><span class="blind">삭제</span></button></span></li>';

  //인기검색어
  var popularItemTemplate =
    '<li><a href="#{{text}}"><b>{{index}}.</b>{{text}}</a></li>';

  //정렬 셀렉트
  //prettier-ignore
  var sortSelectTempate =
    '<select class="ui_selectbox" title="정렬">' +
      '<option value="best">추천순</option>' +
      '<option value="date">최신순</option>' +
      '{{#if isBusiness}}' +
      '<option value="pricedesc">가격 높은순</option>' +
      '<option value="priceasc">가격 낮은순</option>' +
      '{{/if}}' +
    '</select>'

	// unit별 상단 소팅 영역
	var unitTitleTemplate =
		'<div>'+
			'<div class="sort-area left">' +
				'<p class="sort-tit">사업자몰 {{title}}</p>' +
			'</div>' +
			'<div class="sort-area">' +
				'<div class="sort-list">' +
					'<div class="sort-select-wrap">' +
						'{{#if unit=="product"}}' +
							sortSelectTempate + 
						'{{/if}}' +
					'</div>' +
				'</div>' +
			'</div>' +
			'<div class="mob-sort-check obs">' +
				'{{#if tomorrow.show}}' +
					'<span class="chk-wrap tomorrow-delivery">'+
						'<input type="checkbox" id="tomorrow_chk01" name="tomorrow_chk1" {{#if tomorrow.checked}}checked{{/if}}>' +
						'<label for="tomorrow_chk01">내일배송</label>' +
					'</span>' +
				'{{/if}}' +
			'</div>'+
		'</div>';

   //내일 배송 확대
   //prettier-ignore
   var topTomorrowTemplate =  
          '<span class="chk-wrap tomorrow-delivery">' +
            '<input type="checkbox" id="tomorrow_chk02" name="tomorrow_chk2" {{#if tomorrow.checked}}checked{{/if}}>' +
            '<label for="tomorrow_chk02">내일배송</label>' +
          '</span>';

  // 전체보기/닫기 버튼
  //prettier-ignore
  var moreTemplate =
    '<div class="result-allview" data-all-result-cnt="{{count}}">' +
      '<a href="#n">{{unitName}} 전체보기<em>({{count}})</em></a>' +
    "</div>" +
    '<div class="result-allview fixed" style="display:none;">' +
      '<a href="#n">전체보기 닫기</a>' +
    "</div>";
  
  // 내일배송 레이어 텍스트 문구
  var tempDelivTomorrow =
      '{{#each (item, idx) in deliveryTomorrowList}}'+ 
          '<div class="delivery-info">'+
              '<span class="title">{{item.delivTitle}}</span>'+
              '<span class="text">{{item.delivDtText}}</span>'+
          '</div>'+
      '{{/each}}';
  
  // 최근검색어 저장 공유 도메인 e.g. ".lge.co.kr"
  var lgeHost = location.hostname.replace(/.+(?=lge\.)/i, ".");

  var linkHost =
    window.LGEAPPHostName === "localhost" ? "https://wwwdev50.lge.co.kr" : "";
  var search;
  $(document).ready(function () {
    search = {
      init: function () {
        var self = this;

        self.uniqId = vcui.getUniqId(8); // 세션에 검색 내용 저장을 위한 키
        self.savedFilterData = null; // 저장된 필터 데이터 // {support: ['', ..], ..}
        self.savedSmartFilterData = null; // 저장된 스마트 필터 데이터 // {product: ['', ..], ..}
        self.sortData = null; // 저장된 정렬 데이터 // {product: 'best', support: 'date' ...}
        self.fixedAreaH = 0; // 상단 sticky 높이
        self.device = "";
        self.intersection = null; // filter 활성화/비활성화 intersection
        self.moreIntersection = null; // 전체보기 닫기 버튼 intersection
        self.breakIntersection = false; // 유닛탭 클릭 시 intersection 안먹게하는 flag 변수
        self.moreUnitName = null; // 전체보기 중인 유닛
        self.modalUnitName = null; // 팝업 중인 유닛
        self.scrollDirection = "up"; // 스크롤 방향 // "up" 기본이어야 최상위(first) 체크 가능
        self.uiState = {
          doc: {
            ypos: 0, // 화면 scroll ypos
          },
          product: {
            listIndex: 0, // 리스트 활성화 (아코디언)
            tabIndex: 0, // 리스트 내 탭 활성화
            story: {
              id: null, // 리스트 내 스토리 아이디
              page: 0, // 리스트 내 스토리 탭 컨텐츠 페이징
              scrollX: 0, // 리스트 내 스토리 탭 컨텐츠 스크롤
            },
          },
          modal: {
            scrollY: 0, // 팝업 scroll ypos
          },
        };
        self.unitSort = []; // 유닛 정렬 순서
        self.coachKey = "search_all_coach"; // 코치마크 쿠키 key
        self.scrollAction = 1;  //스크롤 처음 체크
        $(window).scrollTop(0);

        vcui.require(
          [
            "ui/pagination",
            "ui/rangeSlider",
          ],
          function () {
            self.plpObj = plpItemB2b;
            self.setting();
            self.bindEvents();

            self.setUnitSort(true); // self.unitSort 초기 설정 용도

            var hash = location.hash.replace("#", "");
            var savedData = lgkorUI.getStorage(hash) || {}; // 체크 여부 판단!
            
            if (savedData.hasOwnProperty("search") && savedData.search !== "") {
              // 세션에 검색 정보 존재 시

              // 정렬
              self.sortData = JSON.parse(savedData.sort);

              // 필터 데이터 저장
              self.setSavedFilterData(
                JSON.parse(self.makeArrFilterData(savedData.filterData)),
                JSON.parse(self.makeArrFilterData(savedData.smartFilter))
              );

              // 저장된 스크롤 위치 정보
              if (savedData.href) self.scrollHref = savedData.href;

              // 저장된 검색어 정보
              if (savedData.search) {
                self.$inputSearch.val(savedData.search);
                self.$inputSearchFixed.val(savedData.search);
              }

              // 세센에 의한 검색
              self.requestSearchData(
                savedData.search,
                savedData.force,
                savedData
              );
            } else {
              //입력된 검색어값 조회
              var value =
                lgkorUI.getParameterByName("search") ||
                self.$contentsSearch.attr("data-search-value");

              value = !value ? null : value.trim();
              var force = lgkorUI.stringToBool(
                self.$contentsSearch.attr("data-search-force")
              );

              // 정렬
              self.sortData = self.getSortValues();

              if (!!value) {
                // data-search-value 혹은 url 파라미터 검색어로 검색
                self.setinputSearchValue(value);
                self.requestSearchData(value, force);
              } else {
                // 검색어 없음
                self.setinputSearchValue("");
                self.requestSearchData("", force);
              }
            }

            self.breakpointChecker();
            self.srchTooltip();
          }
        );
      },

      setting: function () {
        var self = this;

        //타이머
        self.searchTimer = null;

        //통합검색 레이어
        self.$contentsSearch = $("div.contents.search");

        //input-keyword
        self.$inputKeyword = self.$contentsSearch.find(
          "div.input-keyword:eq(0)"
        );
        //검색어 입력input
        self.$inputSearch = self.$inputKeyword.find("div.input-sch input.txt");
        //스크롤 fixed 검색어 입력창
        var inputSearchFixed = self.$contentsSearch.find(
          "div.input-keyword:eq(1)"
        );
        self.$inputSearchFixed = inputSearchFixed.find(
          "div.input-sch input.txt"
        );

        //검색버튼
        self.$buttonSearch = self.$inputKeyword.find(
          "div.input-sch button.btn-search"
        );
        self.$cameraSearch = self.$inputKeyword.find(
          "div.input-sch button.btn-camera"
        );
        self.$buttonSearchFixed = inputSearchFixed.find(
          "div.input-sch button.btn-search"
        );

        //<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 레이어 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        //검색어 리스트 레이어
        self.$searchInputLayer = self.$inputKeyword.find(
          "div.search-input-layer"
        );
        //검색어 최근,인기,많이 찾는 증상 컨테이너
        self.$searchKeywordArea = self.$searchInputLayer.find(
          "div.search-keyword-area"
        );
        //최근 검색어 리스트
        self.$recentKeywordList =
          self.$searchKeywordArea.find("div.recent-keyword");
        //인기 검색어 리스트
        self.$popularKeywordList = self.$searchKeywordArea.find(
          "div.popular-keyword"
        );
        //자동 완성 리스트
        self.$autoComplete = self.$searchInputLayer.find("div.auto-complete");
        //검색어 결과 없음
        self.$notResult = self.$searchInputLayer.find("div.not-result");
        //검색어 리스트 닫기 버튼
        self.buttonClose = self.$searchInputLayer.find(".layer_close");
        //>>>>>>>>>>>>>>>>>>>>>>>>>>>> 레이어 >>>>>>>>>>>>>>>>>>>>>>>>>>>>

        //cont-wrap
        self.$contWrap = self.$contentsSearch.find("div.cont-wrap");
        self.$searchResultWrap = self.$contWrap.find("div.search-result-wrap");
        self.$fixedArea = self.$contWrap.find(".result-area > .list-sorting");

        //필터
        self.$layFilter = self.$contWrap.find("div.lay-filter");
        //A필터
        self.$aFilterTab = self.$contWrap.find("div.nafilter_tabs");
        //필터 안내
        self.$layFilter.$layFilterInfo = $("#smartfilter-info");
        //검색어 영역 컨테이너
        self.$inputKeywordWrap = self.$contentsSearch.find(
          "div.input-keyword-wrap"
        );
        //데체키워드
        self.$searchSimilar = self.$inputKeywordWrap.find("div.search-similar");

        //<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 결과없음 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        // nodata 컨테이너
        self.$searchNotResult = self.$contentsSearch.find(
          "div.search-not-result"
        );
        // 이런 제품 어떠세요
        self.$listNoData = self.$contentsSearch.find("div.list-no-data");

        //nodata - "" 검색결과가 없습니다.
        self.$searchWordArea = self.$searchNotResult.find(".search_word_area");
        //nodata - 다시 한번 확인해 주세요.
        self.$searchAgainMsg = self.$searchNotResult.find(
          ".search_word_msg:eq(0)"
        );

        //nodata - 검색어를 입력해주세요
        self.$searchNotNone = self.$searchNotResult.find("span.txt-none");

        //nodata - 결과를 찾으셨나요?
        self.$searchNotSimilar = self.$searchNotResult.find(
          "span.search-similar"
        );
        //nodata - 결과를 찾으셨나요? 앞 <em>
        self.$searchNotResultText = self.$searchNotSimilar.find(
          "em.search-result-text"
        );
        //nodata - 결과를 찾으셨나요? 아래 검색결과로 이동 링크
        self.$searchNotSimilarA = self.$searchNotResult.find("a.similar-text");
        //>>>>>>>>>>>>>>>>>>>>>>>>>>>> 결과없음 >>>>>>>>>>>>>>>>>>>>>>>>>>>>

        self.$autoComplete.hide();
        self.$notResult.hide();

        //배너
        self.$searchBanner = self.$contentsSearch.find("div.search-banner");

        //검색 결과 - 카테고리
        self.$searchResultCategory = self.$contentsSearch.find(
          "div.search-result-category"
        );

        //<<<<<<<<<<<<<<<<<<<<<<<<<<<<< 신규 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        self.$unitListWrap = self.$searchResultWrap.find(
          ".result-list-wrap:not(.list-no-data) > .list-wrap"
        );
        
        // BTOCSITE-49302 [모니터링 G] 제품비교하기 초기화시에도 선택되어 있는것 처럼 노출되는 현상 Start
        // List product
        self.$listProduct = self.$searchResultWrap.find(
          ".result-list-wrap > .list-wrap"
        );
        // BTOCSITE-49302 [모니터링 G] 제품비교하기 초기화시에도 선택되어 있는것 처럼 노출되는 현상 End
        
        // 고객 피드백
        self.$feedbackBoxWrap = self.$contentsSearch.find(".feedback-box-wrap");
        // 고객지원 번호
        self.$businessCustomerSupport = self.$contentsSearch.find(".business-customer-support");
        // 배너
        self.$resultBanner = self.$contWrap.find(".result-banner");
        // 고객지원 컨텐츠
        self.$customerSupport = self.$contWrap.find(".customer-support");
      },

      bindEvents: function () {
        var self = this;

          //BTOCSITE-65394 전체 보기 버튼 푸터와 겹칠때 안보이기
          $(window).on('scroll',function(){
            var footerTop = $('#footer').offset().top - ( window.innerWidth < 768 ? 100 : 156 );
            var $resultBtn = $('.result-allview.fixed');
            var totalBtnTop = $resultBtn.offset().top;
            if(footerTop < totalBtnTop){
              $resultBtn.css('visibility','hidden');
            }else{
              $resultBtn.css('visibility','visible');
            }
          });

        //검색어 창 동기화
        self.$inputSearch.on("input change", function (e) {
          self.$inputSearchFixed.val($(this).val()).trigger("update");
        });
        self.$inputSearchFixed.on("input change", function (e) {
          self.$inputSearch.val($(this).val()).trigger("update");
        });

        //검색버튼
        self.$buttonSearch.on("click", function (e) {
          e.preventDefault();
          clearTimeout(self.searchTimer);
          var searchKeyword = lgkorUI.getStorage('data-searchkeyword');
          if (!searchKeyword || Object.keys(searchKeyword).length === 0 ) {
            self.storageKeyword("1", "search");
          }
          var searchVal = self.$inputSearch.val();
         self.requestSearchInput(searchVal ,"N");
        });

        // 카메라버튼
        self.$cameraSearch.on("click", function (e) {
          var target = $(e.currentTarget);

          self.callCheckLogin(function (result) {
            var uri = "/my-page/manage-products";

            if (!result.data.isLogin) {
              lgkorUI.alert(
                "<h6>보유제품을 등록하시려면<br />로그인이 필요합니다.</h6>",
                {
                  ok: function () {
                    // 보유제품 페이지로 던지면 미로그인시 로그인 페이지로 가기에
                    if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
                  },
                },
                target
              );
            } else {
              if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
            }
          });
        });

        // <- 버튼
        self.$inputKeyword.on("click", ".btn-back", function (e) {
          e.preventDefault();

          historyBack();
        });

        self.$inputSearch.keydown(function (key) {
          if (key.keyCode == 13) {
            key.preventDefault();
            self.$buttonSearch.trigger("click");
          }
          
          if (key.keyCode == 38 || key.keyCode == 40) { 
            var $links = self.$autoComplete.find('div.keyword-list ul li'),
            linkIndex =   0
            count = $links.length;
            if(count > 0 ){ 
              $links.each(function( index, element ) {
                if ($(element).hasClass("on") ) linkIndex = index+1;
                $(element).removeClass("on")
              });
              switch (key.keyCode) {
                  case 38:
                      // up
                      linkIndex = Math.max(0, linkIndex - 1) ; 
                      break;
                  case 40:
                      // down
                      linkIndex = Math.min(count, linkIndex + 1) ; 
                      break;
              }
              if(linkIndex > 0 ) linkIndex = linkIndex -1;  
              $links.eq(linkIndex).addClass('on');
              self.setinputSearchValue($links.eq(linkIndex).find('a').attr("href").replace("#", ""));
            }
          }
        });

        self.$buttonSearchFixed.on("click", function (e) {
          clearTimeout(self.searchTimer);
          var searchVal = self.$inputSearch.val();
          self.storageKeyword("1", "search");
          self.requestSearchInput(searchVal);
        });

        self.$inputSearchFixed.keydown(function (key) {
          if (key.keyCode == 13) {
            key.preventDefault();
            self.$buttonSearchFixed.trigger("click");
          }
        });

        //검색 타이머
        self.$inputSearch.on("input", function (e) {
          clearTimeout(self.searchTimer);

          //자동완성 공백 특수문자 단독 입력시 호출되지 않도록 처리
          var reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
          var searchVal = this.value.trim();
          var searchTestVal = searchVal.replace(reg, "");
          if (searchVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH || searchTestVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH) {
              //성능개선 1차 > 검색 입력창 클릭시 검색시 레이어 결과 호출
              var $list_ul = self.$popularKeywordList.find("div.keyword-list ul");
              if( $list_ul.children().length == 0 ) {
                  self.updateBasicData();
              }
              self.searchTimer = setTimeout(function () {
                  self.$searchKeywordArea.show();
                  self.$autoComplete.hide();
                  self.$notResult.hide();
                  self.openSearchInputLayer(true);
                  self.toggleCamera(true);
              }, 600);
          } else {
            self.searchTimer = setTimeout(function () {
              self.requestSearchAutoComplete(searchVal);
            }, lgkorUI.SEARCH_AUTOCOMPLETE_TIMER);
            self.toggleCamera(false);
          }
        });

        //검색어 리스트 닫기 버튼
        self.buttonClose.on("click", function (e) {
          clearTimeout(self.searchTimer);
          self.openSearchInputLayer(false);
          //self.$inputSearch.focus();
        });

        //최근검색어 클릭
        self.$recentKeywordList.on(
          "click",
          "div.keyword-list ul li span a",
          function (e) {
            e.preventDefault();
            self.storageKeyword("3", "recent");
            self.searchItem($(this));
          }
        );

        //최근검색어 삭제 클릭
        self.$recentKeywordList.on(
          "click",
          "div.keyword-list ul li span button",
          function (e) {
            var text = $(this)
              .siblings("a")
              .first()
              .attr("href")
              .replace("#", "");
            self.removeRecentSearcheText(text);
          }
        );

        // 최근검색어 전체 삭제
        self.$recentKeywordList.on("click", ".all-delete > a", function () {
          self.removeRecentSearcheText();
        });

        //인기검색어 클릭
        self.$popularKeywordList.on(
          "click",
          "div.keyword-list ul li a",
          function (e) {
            e.preventDefault();
            self.storageKeyword("3", "popular");
            self.searchItem($(this));
          }
        );

        //자동완성 리스트 클릭
        self.$autoComplete.on(
          "click",
          "div.keyword-list ul li a",
          function (e) {
            e.preventDefault();
            self.storageKeyword("3", "auto");
            self.searchItem($(this));
          }
        );

        //자동완성 화살표 클릭
        self.$autoComplete.on(
          "click",
          "div.keyword-list ul li button",
          function (e) {
            e.preventDefault();

            self.searchItem($(this).prev("a"), false);
            self.openSearchInputLayer(false);
            self.$inputSearch.focus();
          }
        );

        //대체키워드 클릭
        self.$contentsSearch.on("click", "a.similar-text", function (e) {
          e.preventDefault();

          var searchVal = $(this).attr("href").replace("#", "");

          self.setinputSearchValue(searchVal);
          //현재 선택된 카테고리 기준으로 검색
          self.requestSearchData(searchVal, true);
        });

        //전체보기 열고/닫기 클릭
        self.$searchResultWrap.on(
          "click",
          ".list-wrap .result-allview > a",
          function (e) {
            e.preventDefault();

            var target = $(this).parent();
            var $plpCont = target
              .closest(".list-wrap")
              .find("ul.result-list");
            var plp = $plpCont.data("instance");
            var unitName = plp.getUnit();

            if (!target.hasClass("fixed")) {
              // 전체보기 로딩중 리스트 영역을 밖으로 나갔을 경우 대비
              var st = $(document).scrollTop();
              var DONE = plp.event.DONE;
              $plpCont.one(DONE, function () {
                if (target.next().hasClass("outside")) {
                  // 영역을 벗어났으면 원 위치로
                  $(document).scrollTop(st);
                }
              });

              self.moreList(unitName); // 전체보기 열기
            } else {
              self.closeList(unitName); // 전체보기 닫기
            }
          }
        );

        //메뉴얼, 드라이버 등의 파일 다운로드
        self.$searchResultWrap.on(
          "click",
          ".list-wrap div.btn-area button",
          function (e) {
            var url = $(this).attr("data-file-url");
            if (!!url) {
              window.location = url;
            }
          }
        );

        // 고객지원 컨텐츠 - 제품 문제 해결하기 버튼 클릭
        self.$customerSupport.on("click", "> a", function (e) {
          e.preventDefault();

          var $unitListWrap = self.$searchResultWrap.find(
            ".result-list-wrap > .list-wrap"
          );

          if (!$unitListWrap.eq(0).hasClass("support")) {
            self.upperUnit("support");

            // 스크롤 이동
            self.filterLayer.changeUnitTab("support");
          } else {
            var unitNameArr = self.unitSort.concat([]).reverse();
            unitNameArr.forEach(function (unitName) {
              self.upperUnit(unitName);
            });
          }
        });

        // 고객 피드백
        self.$feedbackBoxWrap.on("click", ".search-btn", function (e) {
          var target = $(e.currentTarget);
          var checkedRadio = target
            .siblings(".select-list-wrap")
            .find("input[type=radio]:checked");

          var contentTextArea = target
            .siblings(".feedback-input")
            .find("textarea");

          if (checkedRadio.length && contentTextArea.length) {
            self.requestFeedBack(checkedRadio.val(), contentTextArea.val());
          }
        });

        //리스트 정렬 선택시 필터의 정렬 값도 선택하게함
        self.$searchResultWrap.on("change", ".ui_selectbox", function (e) {
          var target = $(e.currentTarget);
          var $plpCont = target.closest(".list-wrap").find("ul.result-list");
          var unitName = $plpCont.data("unit");
          self.storageKeyword("2", "sort"); //정렬 클릭 로그
          self.filterLayer.triggerChangeEvent({ unit: unitName });
        });

        // 팝업 오픈 리스너
        var $popup = $(".morelist-layer");
        $popup
          .off("modalshow")
          .on("modalshow", self.openPopupComplete.bind(self));

        // [내일 배송] 팝업 오픈 리스너
        var $delivPopup = $(".delivery-pop");
            $delivPopup.off("modalshow").on("modalshow", self.openDeliveryPopupComplete.bind(self));
        
        var scrollStatus = new ScrollStatus();
        scrollStatus.init({
          namespace: "search",
          initUpdate: true,
          exChange: function (data) {
            if (data.direct && self.scrollDirection !== data.direct) {
              if (!data.scrolling && self.device === "mobile") {
                self.scrollDirection = data.direct;
                self.initIntersection();
              } else if (self.device === "pc") {
                self.scrollDirection = data.direct;
                self.initIntersection();
              }
            }
          }.bind({ self: self }),
        });

        //스크롤 이벤트
        $(window).on("scroll.search", function (e) {
          if (self.device === "pc") scrollStatus.update();

          self.scrollToToggle();
        });

        $(window).on("resize.search", function (e) {
          self.winH = $(window).height();
        });

        //비교하기 컴포넌트 변화 체크
        $(window).on("changeStorageData", self.setCompares.bind(self));

        // 미디어 쿼리
        $(window).on(
          "breakpointchange.search",
          self.breakpointChecker.bind(self)
        );

        //검색 이동 로그 쌓기
        $("body").on(
          "click",
          "ul.result-list a, ul.morelist_wrap a",
          function (e) {
            self.sendLog(this);
            var href = $(this).attr("href");

            if (href && href.indexOf("#") !== 0) {
              if (
                $(this).hasClass("ios_blank") &&
                isApp() &&
                vcui.detect.isIOS
              ) {
                e.preventDefault();

                // IOS 앱 인경우 링크 처리
                var jsonString = JSON.stringify({
                  command: "sendOutLink",
                  url: href,
                });
                webkit.messageHandlers.callbackHandler.postMessage(jsonString);
              } else {
                self.saveUIState();
              }
            }
          }
        ); 
        
        //상단 체크
        self.$contWrap.on("click", "#tomorrow_chk02", function (e) {
           self.tomorrowChk(e);
        });
        // 내일 배송 체크 박스
        self.$unitListWrap.on("click", "#tomorrow_chk01", function (e) {
          self.tomorrowChk(e); 
        });
        
        // 비교하기 상태 변화 리스너
        $(".component.KRP0015").on(
          "DOMSubtreeModified propertychange",
          function (e) {
            var $target = $(e.currentTarget);
            var transition = window.getComputedStyle($target.get(0)).transition;

            if (transition && transition.indexOf("all") == 0) {
              if ($target.find(".is-active").length) {
                self.$contentsSearch
                  .removeClass("compare-close")
                  .addClass("compare-open");
              } else {
                self.$contentsSearch
                  .removeClass("compare-open")
                  .addClass("compare-close");
              }
            } else {
              self.$contentsSearch.removeClass("compare-open compare-close");
            }
          }
        );

        // 비교하기 후 돌아왔을 때 상태 기억 위한 리스너
        $(".component.KRP0015").on("click", ".btn-compare", function () {
          self.saveUIState();
        });

        // 검색 > 가격필터(LG UP가전 2.0 구독 / 케어십 구독)
        $('#layerNoDataPopup').on('click','.btn',function(){
			$('#layerNoDataPopup').vcModal('hide');
			// 결과 있는 이전 필터 데이터
			var savedData = lgkorUI.getStorage(self.uniqId);
			if (savedData.preFilterData) {
				self.requestReSearchData(_.cloneDeep(savedData.preFilterData));
			}
	    });
        // 검색 입력창 클릭시 검색시 레이어 결과 호출
        self.$inputSearch.on('click', function() {
            var $list_ul = self.$popularKeywordList.find("div.keyword-list ul");
            if( $list_ul.children().length == 0 ) {
                self.updateBasicData();
            }
            self.openSearchInputLayer(true);
        //BTOCSITE-65352 검색 결과 페이지 입력창 포커싱시 앱하단바 계속 노출 버그픽스
        }).on('focusout',function(){
          if(self.$searchInputLayer.css('display') == 'block'){
            lgkorUI.showBottomMeun(false);
          }
        });
        self.$searchInputLayer.on('touchstart',function(){
         lgkorUI.showBottomMeun(false);
        });

      },
      // 내일배송
      tomorrowChk: function ( e) { 
    	  var self = this;
          var target = $(e.currentTarget);
          var checked = target.prop("checked");

          // 특정 필터 input 변경 발생
          self.filterLayer.changeFilterInput(
            "product",
            "producttype",
            "tomorrow",
            checked
          );
      } ,
      /**
       * 로그인 체크
       */
      callCheckLogin: function (callback) {
        var ajaxUrl = $("header").data("login-info");

        if (!ajaxUrl) {
          return;
        }

        lgkorUI.requestAjaxDataPost(
          ajaxUrl,
          {},
          function (result) {
            if (callback) callback(result);
          }.bind(this)
        );
      },

      sendLog: function (dm) {
        var self = this;
        var search = self.$contentsSearch.attr("data-search-value");
        var contentType = $(dm).parents(".result-list").data("unit");
        var gaId = lgkorUI.getCookie("_ga") ;
           // 선택된 li의 인덱스 계산
        var liIndex = $(dm).closest("li").index()+1; 
        var param = {          
          tab:   "all",
          contentType: contentType,
          index : liIndex || 0, 
          linkUrl: dm.href,
          keyword: search,                 
          gaId : gaId,
          serviceName: "B2B" 
        };     
        lgkorUI.requestKongAjax("searchsvc", "/ajax/v1/search/log-keyword-click-save", {
          method: "POST",                
          contentType: "application/json;charset=UTF-8",
          data: JSON.stringify(param),  // Stringify the param object to send as JSON body
          success: function(result) {
            //성공
          },
          error: function(jqXHR) {
            void 0; 
          } 
        });

      },

      breakpointChecker: function () {
        var self = this;
        var breakpoint = window.breakpoint;

        self.device = breakpoint.name;

        switch (breakpoint.name) {
          case "pc":
            self.fixedAreaH = 94;
            break;
          case "mobile":
            if (self.$layFilter.hasClass("hide-tab")) {
              self.fixedAreaH = 58 + 55; // top + tag height
            } else {
              self.fixedAreaH = 58 + 59 + 55; // top + tab + tag height
            }

            break;
          default:
        }

        // rootMargin 재정의를 위한 실행
        self.initIntersection();
      },

		/**
		 * 스크롤 반응하는 요소 컨틀롤
		 */
		scrollToToggle: function () {
			var self = this;
			var scrollTop = $(window).scrollTop();
		
			self.uiState.doc.ypos = scrollTop;
		
			var $thresholdTarget = self.$inputKeyword;
		
			if ($thresholdTarget.length) {
				var threshold =
					self.device === "pc"
					? $thresholdTarget.offset().top + $thresholdTarget.outerHeight()
					: 1;
		
				// search 영역
				self.$fixedArea.toggleClass("fixed", threshold < scrollTop);
			}
		
			// 필터 스크롤 컨트롤
			if (self.filterLayer && self.filterLayer.loaded) {
				self.filterLayer.scrollHandler();
			}
		},

      //검색어 검색창에 입력하기 (fixed와 같이 동기화 하기 위함)
      setinputSearchValue: function (val) {
        var self = this;
        self.$inputSearch.val(val).change();
      },

      //검색어창에 입력후 검색
      searchItem: function ($item, isTrigger) {
        var self = this;
        var searchVal = $item.attr("href").replace("#", "");
        var trigger = isTrigger === undefined ? true : isTrigger;

        self.setinputSearchValue(searchVal);

        if (trigger) self.$buttonSearch.trigger("click");
      },

      /**
       * 검색 레이어 데이터 갱신
       */
      updateBasicData: function () {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-basic-url");
        lgkorUI.requestAjaxData(ajaxUrl, null, function (result) {
          var data = result.data;

          //인기검색어
          var arr =
            data.popular && data.popular instanceof Array ? data.popular : [];

          if (arr.length > 0) {
            var $list = self.$popularKeywordList.find("div.keyword-list");
            $list.empty().append("<ul></ul>");
            if (arr.length > 5) $list.append("<ul></ul>"); // 5개 이상 때 추가 ul
            $list_ul = $list.find("> ul");

            arr.forEach(function (item, index) {
              $list_ul.eq(Math.floor(index / 5)).append(
                vcui.template(popularItemTemplate, {
                  text: item,
                  index: index + 1,
                })
              );
            });
            self.$popularKeywordList.show();
          } else {
            self.$popularKeywordList.hide();
          }
        });
      },

      /**
       * 최근 검색어 추가
       * @param {string} text 검색어
       */
      addRecentSearcheText: function (text) {
        // 스페이스바(공백제거) & 특수문자 치환(¡¿¡)
        var _text = text.trim().replaceAll('|','').replaceAll('&','¡¿¡');
        
        if (!_text || _text.length < 1) return;
        var self = this;

        // 쿠키 *.lge.co.kr 에 공유하기 위함
        lgkorUI.cookieDomain = lgeHost;

        lgkorUI.addCookieArrayValue(lgkorUI.INTERGRATED_SEARCH_VALUE_B2B, _text, lgkorUI.MAX_SAVE_RECENT_KEYWORD_B2B);
        self.updateRecentSearchList();

        lgkorUI.cookieDomain = null;
      },

      /**
       * 최근 검색어 삭제
       * @param {string} text 검색어
       */
      removeRecentSearcheText: function (text) {
        var self = this;

        // 쿠키 *.lge.co.kr 에 공유하기 위함
        lgkorUI.cookieDomain = lgeHost;

        if (text) {
          lgkorUI.removeCookieArrayValue(
            lgkorUI.INTERGRATED_SEARCH_VALUE_B2B,
            text
          );
        } else {
          lgkorUI.deleteCookie(lgkorUI.INTERGRATED_SEARCH_VALUE_B2B);
        }

        self.updateRecentSearchList();

        lgkorUI.cookieDomain = null;
      },

      /**
       * 최근 검색어 리스트 갱신
       */
      updateRecentSearchList: function () {
        var self = this;
        var cookieValue = lgkorUI.getCookie(lgkorUI.INTERGRATED_SEARCH_VALUE_B2B);
        var searchedList = cookieValue ? cookieValue.split("|") : [];
        var arr = searchedList instanceof Array ? searchedList : [];
        var $list_ul = self.$recentKeywordList.find("div.keyword-list ul");
        $list_ul.empty();
        if (arr.length > 0) {
          arr.forEach(function (item, index) {
            var _text = item.trim().replaceAll('¡¿¡','&');
            if(_text) {
                $list_ul.append(vcui.template(recentItemTemplate, { text: _text }));
            }
          });
          self.$recentKeywordList.show();
          self.$recentKeywordList.find("div.no-data").hide();
        } else {
          self.$recentKeywordList.hide();
          self.$recentKeywordList.find("div.no-data").show();
        }
      },

      /**
       * 검색어 줄임
       * @param {string} value 검색어
       * @returns
       */
      ellipsisValue: function (value) {
        if (value.length > 17) {
          return value.substring(0, 18) + "...";
        }
        return value;
      },

      /**
       * 카메라 버튼 토글
       * @param {boolean} show
       */
      toggleCamera: function (show) {
        var self = this;

        if (isApp() && show) {
          self.$buttonSearch.hide();
          self.$cameraSearch.show();
        } else {
          self.$buttonSearch.show();
          self.$cameraSearch.hide();
        }
      },

      openSearchInputLayer: function (open) {
        var self = this;
        if (open) {
            if(window.innerWidth < 768){
              $("html").addClass("scroll-fixed");
              $("body").addClass("scroll-lock");
            }
            self.updateRecentSearchList();
            self.$searchInputLayer.show();
            self.$inputKeywordWrap.addClass("key-fixed");
            self.$inputKeyword.addClass("focus-on");
            // 모바일웹,앱 하단메뉴 노출 여부 설정
            lgkorUI.showBottomMeun(false)
        } else {
            if(window.innerWidth < 768){
              $("html").removeClass("scroll-fixed");
              $("body").removeClass("scroll-lock");
            }
            self.$searchInputLayer.hide();
            self.$inputKeywordWrap.removeClass("key-fixed");
            self.$inputKeyword.removeClass("focus-on");
            // 모바일웹,앱 하단메뉴 노출 여부 설정
            lgkorUI.showBottomMeun(true)
        }

        // 영역 밖 외부 클릭 시 닫기
        self.closeSearchInputLayerListener(open);
      },

      /**
       * 검색 레이어 닫기 리스너 등록 & 해제 (document 클릭 시 닫기)
       * @param {boolean} value 이벤트 등록 유무
       */
      closeSearchInputLayerListener: function (value) {
        var self = this;

        if (value) {
          $(document)
            .off("click.search")
            .on("click.search", function (e) {
              var target = $(e.target);

              if (!target.closest(".input-keyword.focus-on").length) {
                self.buttonClose.trigger("click");
              }
            });
        } else {
          $(document).off("click.search");
        }
      },

      /**
       * reload 검색
       * @param {string} searchUrl
       * @param {*} search
       * @param {*} force
       */
      sendSearchPage: function (searchUrl, search, force) {
        if (searchUrl) {
          var fi = searchUrl.indexOf("?");
          var url =
            searchUrl +
            (fi < 0 ? "?" : "&") +
            "search=" +
            encodeURIComponent(search) +
            "&force=" +
            force;

          location.href = url;
        }
      },

      /**
       * 검색어 입력중 자동완성
       * @param {string} value 검색어
       */
      requestSearchAutoComplete: function (value) {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-autocomplete-url");
        lgkorUI.requestAjaxData(ajaxUrl, { search: value }, function (result) {
          var param = result.param;
          var data = result.data;

          var searchedValue = param.search;
          var replaceText =
            '<span class="search-word">' + searchedValue + "</span>";

          var showAutoComplete = false;

          //자동완성 리스트 갱신
          var arr = data && data.listData instanceof Array ? data.listData : [];
          var $list_ul = self.$autoComplete.find("div.keyword-list ul");
          $list_ul.empty();
          if (arr.length > 0) {

            arr.forEach(function (item, index) {
              // HTML 태그를 안전하게 제거하는 함수
              function stripHtml(html) {
                var temp = document.createElement('div');
                temp.innerHTML = html;
                return temp.textContent || temp.innerText || '';
              }
              $list_ul.append(
                vcui.template(autoCompleteItemTemplate, {
                  input:  stripHtml(item),  // DOM API를 사용하여 안전하게 HTML 태그 제거
                  text: vcui.string.replaceAll(
                    item,
                    searchedValue,
                    replaceText
                  ),
                })
              );
            });
            showAutoComplete = true;
          }

          // [BTOCSITE-86615] 사업자몰(B2B) 구독 도입 : 자동완성 키워드 제거
          var $prductList_div = self.$autoComplete.find("div.prod-direct-list");
          $prductList_div.hide();
          //// [BTOCSITE-86615] 사업자몰(B2B) 구독 도입 : 자동완성 키워드 제거
          self.$searchKeywordArea.hide();

          if (showAutoComplete) {
            //검색결과가 있는 경우.
            self.$autoComplete.show();
            self.openSearchInputLayer(true);

            // ajax done 이전에 텍스트가 지워졌을 경우 대응 다시 최근,인기,많이 찾는 증상 레이어 노출
            if (!self.$inputSearch.val().length) {
              self.$autoComplete.hide();
              self.$searchKeywordArea.show();
            }
          } else {
            //검색결과를 표시할것이 없을경우
            self.$autoComplete.hide();
            self.openSearchInputLayer(false);
          }
        });
      },

      /**
       * input 박스에 의한 검색
       * @param {string} value 검색어 
       * @param {string} api호출 여부 Y/N - 디폴트 빈값
       */
      requestSearchInput: function (value , isApi) {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-search-url");

    	if(isApi !="N"){
            lgkorUI.requestAjaxData(
                    ajaxUrl,
                    { search: value },
                    function (result) {
                      self.openSearchInputLayer(false);

                      //검색어 저장
                      self.$contentsSearch.attr("data-search-value", value);
                      self.$contentsSearch.attr("data-search-force", false);

                      self.sendSearchPage(location.pathname, value, false);
                    }
                  );
    	}else{
            self.openSearchInputLayer(false);

            //검색어 저장
            self.$contentsSearch.attr("data-search-value", value);
            self.$contentsSearch.attr("data-search-force", false);

            self.sendSearchPage(location.pathname, value, false);
    	}
      },

      /**
       * 전체보기 에 의한 재검색
       * @param {object} data // {unit: 'product', isMore: true}
       */
      requestSearchMore: function (data) {
        var self = this;

        self.filterLayer.triggerChangeEvent(data);

        self.moreUnitName = data.unit;

        self.saveUIState();
      },

      // 로그인 정보
      getLoginInfo: function() {
      	var self = this;
        
        self.$contentsSearch.attr("data-partner-type", "");
        self.$contentsSearch.attr("data-partner-cd", "");
        self.$contentsSearch.attr("data-bsnsMbrStat", "");
        self.$contentsSearch.attr("data-islogin", "false");
        
        // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
        self.$contentsSearch.attr("data-partner-type", digitalData.userInfo.partnerType);
        if (digitalData.userInfo.partnerType == "ENT") {
            self.$contentsSearch.attr("data-partner-cd", "99999");
        }else {
            self.$contentsSearch.attr("data-partner-cd", digitalData.userInfo.partnerCode);
        }
        self.$contentsSearch.attr("data-bsnsMbrStat", digitalData.userInfo.bsnsMbrStat);
        self.$contentsSearch.attr("data-islogin", digitalData.userInfo.isLogin);
        
      },
      /**
       * 검색
       * @param {string} value 검색어
       * @param {*} force
       */
      requestSearchData: function (value, force, filterQueryData) {
        var self = this;
        
        self.getLoginInfo();

        var ajaxUrl = self.$contentsSearch.attr("data-search-url");
        var postData = {
          search: value,
          force: force,
          partnerType: self.$contentsSearch.attr("data-partner-type"),
          partnerCd: self.$contentsSearch.attr("data-partner-cd"),
          sort: JSON.stringify(self.sortData),
        };

        if (filterQueryData) $.extend(postData, filterQueryData);

        // 새로 생성된 검색정보(필터 선택 포함) 세션에 저장 후 url#hash 교체
        self.setSessionStorage(postData);
        location.hash = self.uniqId;

        // ajax req 불필요한 데이터 제거
        postData = self.makePayloadData(postData);

        // 레이아웃 초기화
        self.setLayout();

        lgkorUI.showLoading();
        lgkorUI.requestAjaxData(ajaxUrl, postData, function (result) {
          var param = result.param;
          var inputValue = param.inputValue;
          var splitYN = param.splitYN;
          var searchedValue = param.search;

          //검색어 저장
          self.$contentsSearch.attr("data-search-value", searchedValue);
          self.$contentsSearch.attr("data-search-force", force);

          // 대체키워드 존재
//[BTOCSITE-83467] 사업자몰 검색결과없음 오류
//          if (inputValue && inputValue != searchedValue) {
//            if (splitYN != "Y") {
//              // 보정된 키워드로 검색결과 제공
//              var $similarP = self.$searchSimilar.find("p:not('.split')");
//              $similarP.find(".word_area").html(searchedValue);
//              $similarP
//                .find("a.search_word_link")
//                .html(inputValue + " 검색결과 보기")
//                .attr("href", "#" + inputValue);
//              $similarP.show();
//            } else {
//              // 첫 띄어쓰기 전 키워드로 검색결과 제공
//              var $splitP = self.$searchSimilar.find("p.split");
//              $splitP.find(".word_area").html(inputValue);
//              $splitP.find(".search_word_msg em").html(searchedValue);
//              $splitP.show();
//            }
//          }

          var allCount = result.data.allCount;
          self.$searchResultWrap.find(".alllist-count").html("총 " + vcui.number.addComma(allCount) + "개");

          if (allCount == 0) {
            // 검색 결과 없을 때
            self.initNoData(result);
            
            self.$contWrap.show();
			self.scrollToToggle();
          } else {
            // 검색 결과 있을 때
			if (self.filterLayer && self.filterLayer.loaded) {
			  // 각각 unit 리스트 생성
			  self.initList(result);
			} else {
			  // 필터 생성 완료 콜백
			  self.$layFilter.off("loaded").on("loaded", function () {
			    // 각각 unit 리스트 생성
			    self.initList(result);
			  });
			}
			
			// 고객지원 컨텐츠 생성
			self.initSupportContent(result);
			
			// 필터 초기화
			self.initFilter(result);
          }
          self.sendHistoryKeyword  (value,  allCount , 'all');
          //최근검색어 저장
          self.addRecentSearcheText(inputValue);
          self.setDataLayer();
        });
      },

      /**
       * 필터변경에 의한 재검색
       * @param {object} unitQueryData
       */
      requestReSearchData: function (filterQueryData) {
        var self = this;
        
        self.getLoginInfo();
        
        var ajaxUrl = self.$contentsSearch.attr("data-search-unit-url");
        var value = self.$contentsSearch.attr("data-search-value").trim();
        var force = self.$contentsSearch.attr("data-search-force");

        // 정렬 셀렉트 변경에 의해 호출 되므로 전체 sort 데이터 재저장
        self.sortData = self.getSortValues();

        // ui상 필터 정보 객체 self 변수에 저장
        self.setSavedFilterData(
          filterQueryData.filterData,
          filterQueryData.smartFilter
        );

        // 필터 데이터 string 형으로 가공
        var filterDatas = self.makeJsonStrFilterData(filterQueryData);

        // 검색 정보 세션 저장
        self.setSessionStorage({
          search: value,
          force: force,
          partnerType: self.$contentsSearch.attr("data-partner-type"),
          partnerCd: self.$contentsSearch.attr("data-partner-cd"),
          sort: JSON.stringify(self.sortData), // 정렬은 전체유닛 저장
          filterData: filterDatas.filterData,
          smartFilter: filterDatas.smartFilter,
        });

        // 특정 유닛만 재검색
        if (filterQueryData.unitFilterData) {
          var unit = filterQueryData.unitFilterData.unit;

          // 특정 유닛 sort // string 이라 JSON.stringify 불필요
          var sort = self.sortData.hasOwnProperty(unit)
            ? self.sortData[unit]
            : "";

          var $listWrap = self.$unitListWrap.filter("." + unit);
          var $listUL = $listWrap.find("ul.result-list");

          // 특정 유닛 필터 데이터 string 형으로 가공
          var unitFilterDatas = self.makeJsonStrFilterData(
            filterQueryData.unitFilterData
          );

          // 리스트 갯수가 limit 보다 작을때 최소값 req end 유지
//        var pureListNum = $listUL.find("> li").length;
//        var endNum =
//          self.getUnitLimit(unit) > pureListNum
//            ? self.getUnitLimit(unit)
//            : pureListNum;

          // 특정 유닛 조회 req 데이터
          var postData = {
            search: value,
            force: force,
            partnerType: self.$contentsSearch.attr("data-partner-type"),
            partnerCd: self.$contentsSearch.attr("data-partner-cd"),
            sort: sort,
            unit: unit,
            start: 0,
            end: self.getUnitLimit(unit) - 1,
            filterData: unitFilterDatas.filterData,
            smartFilter: unitFilterDatas.smartFilter,
          };

          // ajax req 불필요한 데이터 제거
          postData = self.makePayloadData(postData);

          // 전체보기 버튼에 의해 호출했을 경우
          var isMore = filterQueryData.isMore;

          if (!isMore) {
            lgkorUI.showLoading();

            // 특정 유닛 기본 재검색
            lgkorUI.requestAjaxDataPost(
              ajaxUrl,
              postData,
              function (result) {
              	if (result.count == 0) {
            		$('#layerNoDataPopup').vcModal('show');
            		return;
            	}else {
            		// 결과 있는 이전 필터 데이터 저장
            		self.setSessionStorage({
            			preFilterData: _.cloneDeep(filterQueryData)
            		});
            		
            		// 사용한 객체 삭제
                    delete filterQueryData.unitFilterData;
            	}
                var searchKeyword = lgkorUI.getStorage('data-searchkeyword');
                if (!searchKeyword || Object.keys(searchKeyword).length === 0  ) {
                  self.storageKeyword("2", "filter");     //필터
                }
                self.sendHistoryKeyword  (value,  result.count ,unit);
	            // 특정 unit 데이터 갱신 -필터 전에 데이터 갱신 해줘야 필터에서 data 확인 가능
	            var $listWrap = self.$unitListWrap.filter("." + this.unit);
	            var $plpCont = $listWrap.find("ul.result-list");
	            var plp = $plpCont.data("instance");

	            // 리스트 교체
	            if (plp) {
	              plp.changeList(result); 
	            }
                // 필터 업데이트
                self.updateFilter({ unit: this.unit, res: result });
	            // 특정 unit 리스트 갱신
	            self.updateList({ unit: this.unit, res: result });   
                // 재검색 시 filterLayer.inViewBfilterUnit 호출 안되도록
                self.filterLayer.activatedUnitName = null;

                // 스크롤 위치 복구
                self.filterLayer.restoreUIState();

                // 스크롤 반응하는 요소 컨틀롤
                self.scrollToToggle();
                // 비교하기 활성화 버튼 수정
                self.setCompares();
                // ga 관련 함수 호출
                self.srchTooltip();
                self.setDataLayer();
              }.bind({ unit: unit })
            );
          } else {
            // 전체보기에 의한 특정 유닛 재검색
            var $listWrap = self.$unitListWrap.filter("." + unit);
            var $plpCont = $listWrap.find("ul.result-list");
            var plp = $plpCont.data("instance");

            lgkorUI.showLoading();

            var DONE = plp.event.DONE;
            $plpCont.one(DONE, function () {
              self.setCompares();
              self.srchTooltip();
              self.setDataLayer();
            });
            
            // 특정 유닛 조회 req 데이터
            var postFilterData = {
              filterData: unitFilterDatas.filterData || {},
              smartFilter: unitFilterDatas.smartFilter || {}
            };
            plp.updateData(postFilterData);

            // ajax 호출
            plp.callAjax();
          }
        } else {
          // 전체 재검색 ("결과검색" 변경, 리셋)
          self.requestSearchData(
            value,
            force,
            $.extend(filterQueryData, filterDatas)
          );
        }
      },

      /**
       * 고객피드백 보내기
       * @param {string} value 라디오 버튼 value
       * @param {string} content 컨텐츠 value
       */
      requestFeedBack: function (value, content) {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-feedback-url");
        var keyword = self.$inputSearch.val().trim().length >= 17 ? self.$inputSearch.val().trim() : self.$searchNotResultText.text().trim(); // 입력값
         
        lgkorUI.showLoading();
        lgkorUI.requestAjaxData(
          ajaxUrl,
          {
            keyword: keyword,
            feedbackCode: value,
            feedbackDetail: content,
          },
          function (result) {
            $(window).trigger("toastshow", "피드백 보내기가 완료되었습니다.");
          }
        );
      },

      /**
       * 팝업 오픈 직후 발생 함수
       * @param {*} e
       * @param {*} data
       */
      openPopupComplete: function (e, data) {
        var self = this;
        var ajaxUrl = self.$contentsSearch.attr("data-search-unit-url");
        var $popup = $(e.target);
        var $select = $popup.find(".ui_selectbox");
        var model = data.model;
        var title = data.title;
        var unit = $popup.data("unit") || "";

        // 닫기 시 앱 하단 복구
        $popup.one("modalhide", function (e) {
          self.modalUnitName = null;
          self.saveUIState(); // 팝업 닫힘 상태 저장
        });

        // 정렬 마크업 초기화
        $select.parent().hide();
        if (unit === "disposable") {
	        $select.html(
	          vcui.template(sortSelectTempate, { modal: true, unit: unit })
	        );
        }
        $select.vcSelectbox("update");

        $popup.css("overflow-y", "auto");
        //vcui.require(["search/modules/plpItem-b2b"], function (PlpItem) {
        var plp = self.plpObj();

          var paramData = { search: model, force: false };

          plp.init(
            { param: paramData },
            {
              container: data.href + " .morelist_wrap",
              moreUri: ajaxUrl,
              unit: unit,
              initialList: false,
            }
          );
          var filterData ={};
          var filterDatas ={};
          if(self.filterLayer){
        	// 특정 유닛 필터 정보
        	  filterData = self.filterLayer.getDataFromFilter({
                  unit: unit,
                });  
        	  // 필터 데이터 string 형으로 가공
            filterDatas = self.makeJsonStrFilterData(
                filterData.unitFilterData
            );
          }
 
          var plpData = {
            sort: $select.val(),
            start: 1,
            end: 30, // 호출 전 총갯수 알수 없으므로 일단 목표치 30, callAjax() 에서 조정 됨
            filterData: filterDatas.filterData,
            smartFilter: filterDatas.smartFilter,
            count: 1, // 팝업열림과 동시에 30개 호출 하므로 +1
          };

          // 팝업 저장 데이터 존재 시 (팝업 내 리스트 클릭 후 상세에서 back했을 경우)
          var savedModalData;
          var savedData = lgkorUI.getStorage(self.uniqId);
          if (savedData.uiState) {
            var uiState = JSON.parse(savedData.uiState);

            if (uiState && uiState.hasOwnProperty("modal")) {
              if (uiState.modal.count) {
                var modal = (savedModalData = uiState.modal);

                plpData.end = 30 * modal.count;
                plpData.count = modal.count;
              }
            }
          }

          // 필터 상태 plp 객체에 업데이트
          plp.updateData(plpData);

          // ajax 호출
          plp.callAjax();

          var $plpCont = plp.getTarget();

          // 가로 스크롤 위치 저장
          var CHANGE_SCROLL_Y = plp.event.CHANGE_SCROLL_Y;
          $plpCont.off(CHANGE_SCROLL_Y).on(CHANGE_SCROLL_Y, function (e, data) {
            self.uiState.modal = data;
          });

          // 소모품 팝업에만 필요
          if (unit === "disposable") {
            // 정렬 셀렉트 박스 초기화
            var sortData = $select.val();
            $select.parent().show();
            $select.val(sortData).vcSelectbox("update");

            // 정렬 변경
            $select.off("change").on("change", function (e, data) {
              var target = $(e.currentTarget);
              var $plpCont = target
                .closest(".list-sorting")
                .next(".morelist_wrap");
              var plp = $plpCont.data("instance");

              // 필터 상태 plp 객체에 업데이트
              plp.updateData({ sort: target.val() });

              // 셀렉트 박스 ui update
              $select.val(target.val()).vcSelectbox("update");

              // plp리스트 비움
              plp.clear();

              // ajax 호출
              plp.callAjax();
            });

            // 타이틀
            $popup.find(".prod_name").text(title);
          }

          // 카운트
          var $count = $popup.find(".list_count");
          $count.hide();

          var DONE = plp.event.DONE;
          $plpCont.one(DONE, function (e) {
            // 로딩이 완료되면 갯수 설정
            $count.text(vcui.number.addComma(plp.getTotalCount())).show();

            // 팝업 저장 데이터 존재 시 스클롤 복구
            if (savedModalData) {
              $popup.scrollTop(savedModalData.scrollY || 0);

              // restoreUIState() 에서 제거 유보시킨 uiState 정보 삭제
              delete savedData.uiState;
              lgkorUI.setStorage(self.uniqId, savedData);
            }

            // 팝업 열림 상태 저장
            self.modalUnitName = unit;
            self.saveUIState();
          });
        //});
      },

      /**
       * 팝업 오픈 직후 발생 함수
       * 내일 배송
       * @param {*} e
       * @param {*} data
       */
      openDeliveryPopupComplete :function (e, data) {
        var $delivPop = $(e.target);
        var _deliveryTomorrowList = _.defaultTo(data.deliveryInfo, []);
        var _deliveryType = _deliveryTomorrowList.length == 1 ? _deliveryTomorrowList[0].delivCd : '';
        
        // 배송유형 문구 노출 
        $delivPop.find('.notice-sub_01').hide();
        $delivPop.find('.notice-sub_03').hide();
        $delivPop.find('.notice-list').hide();
        $delivPop.find('#deliveryDescText').show();
        
        if(_deliveryTomorrowList.length > 1) {
            _deliveryTomorrowList.forEach(function (obj, idx) {
                $delivPop.find('.notice-list.notice_'+obj.delivCd).show();
            });
            // 공통사항 노출
            $delivPop.find('.notice-list.notice_com').show();
        }
        
        if(_deliveryType) {
            $delivPop.find('#deliveryDescText').hide();
            $delivPop.find('.notice_'+_deliveryType).show();		 // 배송 유형 영역 TEXT 만 노출
            if(_deliveryType == '01' || _deliveryType == '03') {
                $delivPop.find('.notice-sub_'+_deliveryType).show(); // 배송 유형 SUB 영역 TEXT 만 노출
            }
        }

          // add html
          $delivPop.find('.delivery-area').html(vcui.template(tempDelivTomorrow, {deliveryTomorrowList: _deliveryTomorrowList}));
      },
      
      /**
       * 레이어 초기화
       */
      setLayout: function () {
        var self = this;

        // 검색 레이어 닫기
        self.openSearchInputLayer(false);

        // 결과 없음 영역
        self.$searchNotResult.hide(); // 결과없음 메세지 영역
        self.$listNoData.hide(); // 검색 결과영역 속 nodata 영역

        // 고객 피드백 숨김
        self.$feedbackBoxWrap.hide();
        // 고객지원 번호 숨김
        self.$businessCustomerSupport.hide();

        // 배너
        self.$resultBanner.children().hide();

        // 고객지원 컨텐츠
        self.$customerSupport.hide();
      },

      /**
       * 데이터 없음
       * @param {object} result ajax res
       */
      initNoData: function (result) {
        if (!result) return;

        var self = this;
        var data = result.data;
        var param = result.param;
        var inputValue = param.inputValue;
        var splitYN = param.splitYN;
        var searchedValue = param.search;

        // 제로 키워드 페이지 > 네이버 검색 결과 제외 설정
        $('head').append('<meta name="robots" content="noindex">');
        // 필터없는 레이아웃 css 적용
        self.$searchResultWrap.addClass("no_filter");
        // 그룹핑 안되어 있어서 따로 숨김
        self.$searchResultWrap.find(".result-area").children().hide();
        // 필터 영역 숨김
        self.$layFilter.hide();
        // 피드백 노출
        self.$feedbackBoxWrap.show();
        // 고객지원 번호
        self.$businessCustomerSupport.show();

        // 메세지 태그 초기화
        self.$searchNotResult.show(); // nodata 컨테이너
        self.$searchNotNone.hide(); // 검색어를 입력해주세요
        self.$searchAgainMsg.hide(); // 다시 한번 확인해 주세요.
        self.$searchNotResultText.text(inputValue); // "" 결과를 찾으셨나요? 의 ""
        self.$searchNotSimilar.hide(); // "" 결과를 찾으셨나요?
        self.$searchNotSimilarA.hide(); // 결과로 이동

        // "" 검색결과가 없습니다.
        self.$searchNotResult
          .find(".word_area")
          .text(self.ellipsisValue(searchedValue));

        //"" 검색결과로 이동
//[BTOCSITE-83467] 사업자몰 검색결과없음 오류
//        if (inputValue && inputValue != searchedValue) {
//          var $shortenTxt_1 = inputValue.substring(0, 10);
//          var $shortenTxt_2 = inputValue.substr(inputValue.length - 10, 10);
//
//          // 일반
//          if (splitYN != "Y") {
//            // 다시 한번 확인해 주세요.
//            self.$searchAgainMsg.hide();
//            // "" 결과를 찾으셨나요?
//            self.$searchNotSimilar.show();
//            self.$searchNotResultText.text(inputValue);
//            // 검색결과로 이동
//            self.$searchNotSimilarA.attr("href", "#" + inputValue).show();
//
//            if (inputValue.length >= 17) {
//              self.$searchNotResultText.text(
//                $shortenTxt_1 + " ~ " + $shortenTxt_2
//              );
//            }
//          }
//        } else {
          self.$searchAgainMsg.show();
          self.$searchNotSimilar.hide();
//        }

        // 검색어 미입력 시 "검색어를 입력해주세요" 노출
        if (self.$inputSearch.val().trim() == "") {
          self.$searchAgainMsg.hide();
          self.$searchNotNone.show();
        }
      },

      /**
       * 고객지원 컨텐츠 초기화
       * @param {Object} result
       */
      initSupportContent: function (result) {
        var self = this;
        var param = result.param;
        var searchedValue = param.search;

        var $customerSupport = self.$customerSupport;

        if (lgkorUI.stringToBool(result.data.supportContent)) {
          $customerSupport
            .show()
            .find(".cs_txt")
            .html("혹시 " + searchedValue + " 제품 사용에 문제가 있으신가요?");
        } else {
          $customerSupport.remove();
        }
      },

      /**
       * 필터 초기화
       * @param {Object} result
       */
      initFilter: function (result) {
        var self = this;

        // 1회 생성
        if (!self.filterLayer) {
          self.filterLayer = new FilterLayer(
          self.$layFilter,
          self.$searchResultWrap,
          self.$aFilterTab,
          function (data) {
            // 재 검색
            self.requestReSearchData(data);
          }
        );

          // 유닛탭 클릭 시 발생하는 이벤트
          var event = self.filterLayer.event;
          self.$layFilter.on(event.CLICK_UNIT_TAB, function (e, unitName) {
            var $listWrap = $(".list-wrap").filter("." + unitName);
            var isFixed = self.$contWrap.hasClass("filter_fixed");
            var exH; // 예외 높이 (모바일도 px 이기때문에 수동으로.. css 높이에 따라 height() 계산하기엔 css 영향이 너무 큼)

            // 상단 fixed 유무와 device 에 따라 계산 ( height() 계산으로 받기 어려움 )
            if (isFixed) {
              exH = self.device === "pc" ? 0 : -113;
            } else {
              exH = self.device === "pc" ? 32 : -99;
            }

            // 모바일 탭 버튼 영역 없는 경우 높이 제외
            if (self.$layFilter.hasClass("hide-tab") && self.device !== "pc") {
              exH -= 59;
            }

            if (self.device === "mobile") {
              var aFilterHeight =
                self.$aFilterTab.outerHeight() +
                self.$aFilterTab.siblings(".nafilter_choice").outerHeight();
              exH += aFilterHeight;
            }

            // 전체보기 중인 유닛이 있다면 닫기
            self.deactivatedMore();

            if ($listWrap.length) {
              var st = $listWrap.offset().top - self.fixedAreaH - exH;

              self.moveScrollTop(st, unitName);
            }
          });
        }

        //FilterLayer 내부 생성자 require() 보다 빨라서 데이터만 저장하고 함수내 로직 진행 안함
        var savedFilterData = self.getSumSavedFilterData();
        self.filterLayer.create(result, savedFilterData);
        self.filterLayer.select(savedFilterData);
        
		// 필터 화면탭 초기 셋팅
		self.filterLayer.changeFilterTabFirstInfo();        
      },

      /**
       * 리스트 영역 초기화
       * @param {Object} result
       */
      initList: function (result) {
        var self = this;

        self.$unitListWrap.hide(); // list wrap 모두 숨김

        //vcui.require(["search/modules/plpItem-b2b"], function (PlpItem) {
          var units = [];
          
          self.$contWrap.show();

          // 리스트를 그리기 위한 필터 "검색결과" 체크된 값 배열로 반환하기 위한 로직
          if (self.savedFilterData) {
            units = self.getUnitFilterList(self.savedFilterData);
          } else {
            // 저장데이터 없이 진입인 경우 filterLayer 에서 그려진 "검색결과" input 참조하여 unit 배열 유추
            var unitFilterData = self.filterLayer.getUnitFilterData();
            units = self.getUnitFilterList(unitFilterData);

            // 위에서 유추한 "검색결과" 내용 세션에 추가 저장, 재 진입 시 유지 위함
            self.setSessionStorage({
              filterData: self.makeStrFilterData(
                JSON.stringify(unitFilterData)
              ),
            });
          }

			// 신제품
			if (result.data.hasOwnProperty("new")) {
				if (!isNaN(result.data.new.count) && result.data.new.count > 0) {
				// pc / mo - each
					$(".result-banner > .newproduct").each(function (idx, elm) {
						var plp = new PlpItem();
						var $wrap = $(elm);
		
						var isMobile = $wrap.parent(".mo-only").length;
						$wrap.data("device", isMobile ? "mo" : "pc");
		
						plp.init(result, {
							container: elm,
							unit: "new",
						});
		
						$wrap.show();
					});
					
					// 모바일 상단 프로모션 영역 타이틀 높이조절
					search.promotionBannerHeight();
					$(window).resize(function() {
						if($(window).width() <= 768) {
							search.promotionBannerHeight();
						}
					});
				}
			}
			
			// [모바일인] A필터 노출
			if( self.device == "mobile" && $('.nafilter_anchor.mo-only .tabs li').length > 0 ) {
				self.$contWrap.find('.nafilter_anchor.mo-only').show();
			}

          // "검색결과" 체크만큼 반복 실행
          units.forEach(function (unit) {
            // plp
            var plp = self.plpObj();

            // 신제품 외 모든 unit
            plp.init(result, {
              container: ".list-wrap." + unit + " .result-list",
              moreUri: self.$contentsSearch.attr("data-search-unit-url"),
              moreFun: self.requestSearchMore.bind(self),
              unit: unit,
              sort: self.sortData[unit],
              partnerType: self.$contentsSearch.attr("data-partner-type"),
              partnerCd: self.$contentsSearch.attr("data-partner-cd"),
            });

            var $plpCont = plp.getTarget();

            if (unit === "product") {
              // 탭 변경 저장 이벤트
              var CHANGE_TAB = plp.event.CHANGE_TAB;
              $plpCont.off(CHANGE_TAB).on(CHANGE_TAB, function (e, data) {
                $.extend(self.uiState.product, data);
              });

              var CHANGE_PAGE = plp.event.CHANGE_PAGE;
              $plpCont.off(CHANGE_PAGE).on(CHANGE_PAGE, function (e, data) {
                $.extend(self.uiState.product.story, data);
              });
            }
            if (unit === "event") {
              // 가로 스크롤 위치 저장
              var CHANGE_SCROLL_X = plp.event.CHANGE_SCROLL_X;
              $plpCont
                .off(CHANGE_SCROLL_X)
                .on(CHANGE_SCROLL_X, function (e, data) {
                  self.uiState.event = data;
                });
            }

            // plp wrap (노출 여부 포함)
            self.updateListWrap(plp);

            // 필터 스크롤 리프레쉬
            self.filterLayer.scrollHandler();
          });

          self.initIntersection();
          self.initMoreIntersection();
          self.checkPriorities(result);
          self.checkParams();
          self.restoreUIState();
          self.setCompares();
          self.srchTooltip();
          
          // 렌지초기화 용으로 사용(추후 소스정리필요)
		  self.filterLayer.changeFilterTabFirstInfo();
        //});
      },

      /**
       * 전체보기 열기
       * @param {string} unitName 유닛명
       */
      moreList: function (unitName, data) {
        var self = this;
        var $listWrap = self.$unitListWrap.filter("." + unitName);
        var $plpCont = $listWrap.find("ul.result-list");
        var $moreBtn = $listWrap.find(".result-allview:not('.fixed')"); // 전체보기 열기버튼
        var plp = $plpCont.data("instance");

        // 전체보기
        var sort = self.sortData[unitName];
        var pureListNum = $plpCont.find("> li").length;

        // 전체보기 중인 유닛이 있다면 닫기
        self.deactivatedMore();

        if (plp) {
          plp.updateData({ sort: sort });

          if (!data) {
            plp.more({ min: self.getUnitLimit(unitName) }); // limit 노출 갯수 전달. req start 값으로 사용
          } else {
            // more count 전달, plp.more() 내부 incrementPage()에서 +1 하므로 -1해서 전달
            plp.more($.extend({}, { min: pureListNum, count: data.count - 1 }));
          }
        } 

        $moreBtn.hide().siblings(".fixed").show();
        $plpCont.addClass("more");

        self.checkReserveBanner(unitName);
      },

      /**
       * 전체보기 닫기
       * @param {string} unitName 유닛명
       */
      closeList: function (unitName) {
        var self = this;

        var $listWrap = self.$unitListWrap.filter("." + unitName);
        var $plpCont = $listWrap.find("ul.result-list");
        var $closeBtn = $listWrap.find(".result-allview.fixed"); // 전체보기 닫기버튼
        var plp = $plpCont.data("instance");

        // 닫기
        if (plp) plp.close();

        $closeBtn.hide().siblings(".result-allview:not('.fixed')").show();
        $plpCont.removeClass("more");

        self.moreUnitName = null;

        self.checkReserveBanner(unitName);

        //전체보기 닫기 시 리스트 갯수 상태 저장
        self.saveUIState();
      },

      /**
       * doc 스크롤 이동
       * @param {number} st 스크롤 top
       * @param {string} unitName 유닛탭 클릭 시 toggleFilter 실행 위한 값 (intersection 규칙 피하기 위함)
       */
      moveScrollTop: function (st, unitName) {
        var self = this;
        
        self.scrollAction ++;
        
        // intersection 잠시 중단
        self.breakIntersection = true;

        // 스크롤 아래서 위로 올라오는 intersection 상태를 선행
        $(window).scrollTop(st + 1);

        $("html, body")
          .stop()
          .clearQueue()
          .animate(
            {
              scrollTop: st,
            },
            {
              queue: false,
              duration: 500, // 500 이상 권장 (isIntersecting 이 느리게 반응함)
              complete: function () {
                // html, body 중 1회만 하기 위한
                if ($(this).is("body")) {
                  self.breakIntersection = false;

                  self.filterLayer.toggleFilter(unitName);
                }
              },
            }
          );
      },

      /**
       * 화면상태 세션 저장 // 링크 이동 후 화면 상태 기억했다가 back했을 경우 복구하기 위함
       */
      saveUIState: function () {
        var self = this;

        self.setSessionStorage({
          uiState: JSON.stringify(self.getUIState()),
        });
      },

      /**
       * 화면 복구
       */
      restoreUIState: function () {
        var self = this;

        // 저장된 필터 ui 상태 전달
        var savedData = lgkorUI.getStorage(self.uniqId);

        if (savedData.uiState) {
          var uiState = JSON.parse(savedData.uiState);

          // 이전 상태가 전체보기 상태일때
          if (uiState.more && uiState.more.hasOwnProperty("unit")) {
            var unitName = uiState.more.unit;

            if (unitName) {
              var $listWrap = self.$unitListWrap.filter("." + unitName);
              var $plpCont = $listWrap.find("ul.result-list");
              var plp = $plpCont.data("instance");

              // moreList() > .. > requestReSearchData() > plpItem 의 callAjax() 에서 trigger
              if (plp) {
                var DONE = plp.event.DONE;
                $plpCont.one(DONE, function () {
                  self.moveScrollTop(uiState.doc.ypos); // 위치로 이동
                  self.restoreFilterLayer(uiState);
                  self.restorePlpItem(uiState);
                  self.setCompares();
                  self.srchTooltip();
                  self.setDataLayer();
                });

                // 전체보기 상태로
                self.moreList(unitName, {
                  count: uiState.more.count,
                });
              }
            }
          } else {
            // 일반 상태
            self.moveScrollTop(uiState.doc.ypos); // 위치로 이동
            self.restoreFilterLayer(uiState);
            self.restorePlpItem(uiState);
            self.setCompares();
            self.srchTooltip();
            self.setDataLayer();
          }

          // 팝업 상태
          if (uiState.modal && uiState.modal.hasOwnProperty("unit")) {
            var modal = uiState.modal;

            if (modal && modal.hasOwnProperty("param")) {
              var openerBtn = $(
                'button[data-unit="' +
                  modal.unit +
                  '"][data-model="' +
                  modal.param.search +
                  '"]'
              );

              openerBtn.click(); // 팝업 열기 호출
            }
          } else {
            // ui 복구하면 기존 uiState 정보 삭제
            // 팝업 정보 있는 경우 위 if 통해 팝업 열리고 스크롤 복구 후 제거
            delete savedData.uiState;
            lgkorUI.setStorage(self.uniqId, savedData);
          }
        }
      },

      /**
       * filterLayer 상태 복구함수
       * @param {object} uiState savedData.uiState
       */
      restoreFilterLayer: function (uiState) {
        var self = this;

        if (!self.filterLayer) return;

        if (uiState.bfilter)
          self.filterLayer.setUIState("bfilter", uiState.bfilter);

        if (uiState.afilter)
          self.filterLayer.setUIState("afilter", uiState.afilter);

        self.filterLayer.restoreUIState();
      },

      /**
       * PlpItem 상태 복구함수
       * @param {object} uiState savedData.uiState
       */
      restorePlpItem: function (uiState) {
        var self = this;

        for (unitName in uiState) {
          var data = uiState[unitName];

          if (data) {
            var $listWrap = self.$unitListWrap.filter("." + unitName);
            var $plpCont = $listWrap.find("ul.result-list");
            var plp = $plpCont.data("instance");

            if (plp) {
              // 상태 복구
              plp.restore(data);
            }
          }
        }
      },

      /**
       * 필터 재정의
       * @param {object} data 검색 결과
       */
      updateFilter: function (data) {
        var self = this;
        var unitName = data.unit;

        // 필터 교체
        var resultData = self.filterLayer.getResultData() || { data: null }; // 필터레이어가 담고있는 ajax 결과 데이터
        var unitResultData = data.res || {}; // 재검색 결과
        var filterLayerUnitData = resultData.data[unitName]; // 필터레이어 객체 유닛별 필터 데이터

        // ajax 결과 데이터 특정 유닛 필터 정보 교체
        if (filterLayerUnitData.filterList && unitResultData.filterList) {
          filterLayerUnitData.filterList = unitResultData.filterList;
        }

        if (unitResultData.smartFilterList) {
          filterLayerUnitData.smartFilterList = unitResultData.smartFilterList;
        }

        var savedFilterData = self.getSumSavedFilterData();
        self.filterLayer.create(resultData, savedFilterData);
        self.filterLayer.select(savedFilterData);

        self.initIntersection();
      },

      /**
       * 유닛별 리스트 재정의
       * @param {object} data 검색 결과
       */
      updateList: function (data) {
        var self = this;
        var unitName = data.unit;

        var $listWrap = self.$unitListWrap.filter("." + unitName);
        var $plpCont = $listWrap.find("ul.result-list");
        var plp = $plpCont.data("instance");

        // 리스트 교체
        if (plp) {
          plp.changeList(data.res);
          self.updateListWrap(plp);
        }
      },

      /**
       * 리스트 그룹 상태 변경
       * @param {PlpItem} plp plp instance
       */
      updateListWrap: function (plp) {
        var self = this;
        var totalCount = plp.getTotalCount() || 0;
        var $plpCont = plp.getTarget();
        var $listWrap = $plpCont.closest(".list-wrap");
        var $reserveBanner = $plpCont.nextAll("div[class$='-banner']");
        var unitName = plp.getUnit();
        var unitNameKor = plp.getUnitNameKor();
        var checkFilterWrap = self.$contWrap.find(".check-filter-wrap"); // 내일배송 ,임직원가
        var tomorrowCheckbox = self.$contWrap.find(".tomorrow_checkbox");
        var isTomorrow = false; // 내일 배송
        
        // 제품 유닛에만 필요
        if (unitName === "product") {
          // 내일배송 노출 유무
          isTomorrow = !!self.filterLayer.getFilterInput(
            "product",
            "producttype",
            "tomorrow"
          ).length;
          // 내일 배송 확대
          if(isTomorrow){
          	tomorrowCheckbox.show();
              tomorrowCheckbox.html(
  	            vcui.template(topTomorrowTemplate, {
  	              title: plp.getUnitNameKor(),
  	              unit: unitName,
  	              modal: false,
  	              tomorrow: { show: isTomorrow, checked: self.getTomorrowChecked() } 
  	            })
  	          );
          }else{
          	 tomorrowCheckbox.hide();
          }
        }

        // wrap markup
        $listWrap.find(".list-sorting").html(
          vcui.template(unitTitleTemplate, {
            title: plp.getUnitNameKor(),
            unit: unitName,
            modal: false,
            isBusiness: self.$contentsSearch.attr("data-partner-type") == "ENT" ? true : false,
            tomorrow: { show: isTomorrow, checked: self.getTomorrowChecked() },
          })
        );

        // 전체보기/닫기 버튼 markup
        $listWrap.find(".result-allview_area").html(
          vcui.template(moreTemplate, {
            unitName: unitNameKor,
            notAllBtn: $plpCont.hasClass("boxarea"),
            count: vcui.number.addComma(totalCount),
          })
        );

        // 전체 데이터 기준 전체보기 버튼 토글
        $listWrap
          .find(".result-allview_area")
          .toggle(totalCount > self.getUnitLimit(unitName));

        // 해당 unit list wrap 토글
        $listWrap.toggle(totalCount > 0);

        // 셀렉트 박스
        var selectbox = $listWrap.find(".ui_selectbox").data("ui_selectbox");
        if (selectbox) {
          // 셀렉트 박스 sortData 데이터 있으면 적용
          selectbox.value(self.sortData[unitName], false);
        } else {
          // 셀렉트 박스 초기화
          $listWrap
            .find(".ui_selectbox")
            .val(self.sortData[unitName])
            .vcSelectbox();
        }
        
        // 필터 제품 정렬 데이터 동기화 
        if(unitName === 'product') {
        	$("input[name=filterSort]").filter('input[value='+self.sortData[unitName]+']').attr("checked", "checked");
        }
        
        // 예약 유도 버튼 토글 체크
        self.checkReserveBanner(unitName);
        // 예약 유도 버튼 무한 스크롤 이후 이벤트 리스너
        var IS_LAST = plp.event.IS_LAST;
        $plpCont.off(IS_LAST).on(IS_LAST, function (e, unitName) {
          self.checkReserveBanner(unitName);
        });
      },

      /**
       * 유닛 최상단으로
       * @param {} unitName
       */
      upperUnit: function (unitName) {
        var self = this;

        // 문제해결 유닛 리스트 최상단으로 위치 변경
        self.$unitListWrap
          .parent()
          .prepend(self.$unitListWrap.filter("." + unitName));

        // 순서변경에 대한 selector 재정의
        self.$unitListWrap = self.$searchResultWrap.find(
          ".result-list-wrap:not(.list-no-data) > .list-wrap"
        );
        
        // [mo] 필터 탭 정보 노출 
        self.filterLayer.changeFilterTabInfo();
      },

      /**
       * 전체보기 닫기 버튼 토글 (intersection 용, 부모 elm은 click에 의해 display 조작 중)
       * @param {string} unitName 유닛명
       */
      activateMoreBtnA: function (unitName) {
        var self = this;

        self.$unitListWrap.find(".result-allview.fixed").addClass("outside");

        if (unitName) {
          self.$unitListWrap
            .filter("." + unitName)
            .find(".result-allview.fixed")
            .removeClass("outside");
        }
      },

      /**
       * 활성화된 전체보기 닫기버튼 click 발생시켜 닫기
       */
      deactivatedMore: function () {
        var self = this;

        var visibleCloseMoreBtn = self.$unitListWrap
          .find(".result-allview.fixed > a")
          .not(":hidden");

        visibleCloseMoreBtn.click();
      },

      /**
       * intersection observer 초기화 (유닛별 토글링 기능)
       */
      initIntersection: function () {
        var self = this;
        var topH = self.fixedAreaH + 1; // 유닛 탭 클릭할 때 스크롤 아래서 위로 올라오는 효과를 위해 +1 추가
        var winH = vcui.dom.getWinHeight();

        // 대상
        var $listWrap = self.$unitListWrap.not(":hidden");

        if (!$listWrap.length) return; // breakpoint 최초 실행에서 아직 리스트 로드 전이므로 진행 안함

        // 제거
        self.destroyIntersection();

        //
        self.intersection = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entrie) {
					var target = entrie.target;
					var inter = entrie.isIntersecting;
					var ypos = target.getBoundingClientRect().top;
					var height = target.getBoundingClientRect().height;
					var unitName;
				
					if (target && target.classList.length >= 2) {
						unitName = target.classList.item(1);
					}
					if (self.filterLayer && self.filterLayer.loaded) {
						if (self.breakIntersection) return;
						
						if (self.scrollDirection === "up") {
							if (inter && (ypos <= topH)) {
								self.filterLayer.toggleFilter(unitName);
							}
						
							if ( !inter && ypos > topH && !$(target).prevAll().not(":hidden").length ) { // 이전 element 노출된게 없으면
								self.filterLayer.toggleFilter(unitName); // 첫번째 유지
							}
						} else if (self.scrollDirection === "down") {
							if (inter && ((ypos + height) >= window.innerHeight)) {
								self.filterLayer.toggleFilter(unitName);
							}
						
							if (!inter && ((ypos + height) < (window.innerHeight)) && !target.nextElementSibling ) {
								self.filterLayer.toggleFilter(unitName); // 마지막 유지
							}
						}
					}
				});
			},
			{
			threshold: [0],
			rootMargin:
				self.scrollDirection === "down"
					? "-" + winH + "px 0px 0px 0px"
					: "-" + topH + "px 0px -" + (winH - topH) + "px 0px",
			}
		);

        // init observe
        $listWrap.each(function (idx, elm) {
        	  self.searchTimer = setTimeout(function () {
        		  self.intersection.observe(elm);
              }, 1);
          
        });
      },

      /**
       * intersection observer 제거
       */
      destroyIntersection: function () {
        var self = this;

        if (self.intersection) {
          self.intersection.disconnect();
          self.intersection = null;
        }
      },

      /**
       * more intersection observer 초기화 (유닛별 토글링 기능)
       */
      initMoreIntersection: function () {
        var self = this;
        var winH = vcui.dom.getWinHeight();

        // 대상
        var $listWrap = self.$unitListWrap.not(":hidden");

        if (!$listWrap.length) return; // breakpoint 최초 실행에서 아직 리스트 로드 전이므로 진행 안함

        // 제거
        self.destroyMoreIntersection();

        //
        self.moreIntersection = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entrie) {
              var target = entrie.target;
              var inter = entrie.isIntersecting;
              var ypos = target.getBoundingClientRect().top;
              var unitName;

              if (target && target.classList.length >= 2) {
                unitName = target.classList.item(1);
              }

              if (inter) {
                if (ypos < winH) {
                  self.activateMoreBtnA(unitName);
                }
              } else {
                if (!target.previousElementSibling && ypos > winH) {
                  self.activateMoreBtnA();
                } else if (!target.nextElementSibling && ypos < winH) {
                  self.activateMoreBtnA();
                }
              }
            });
          },
          {
            threshold: [0],
            rootMargin: "-" + winH + "px 0px 0px 0px",
          }
        );

        // init observe
        $listWrap.each(function (idx, elm) {
          self.moreIntersection.observe(elm);
        });
      },

      /**
       * more intersection observer 제거
       */
      destroyMoreIntersection: function () {
        if (self.moreIntersection) {
          self.moreIntersection.disconnect();
          self.moreIntersection = null;
        }
      },

      /**
       * 어드민 unit 우선순위 설정
       * @param {Object} result 검색 결과 데이터
       */
      checkPriorities: function (result) {
        var self = this;

        if (result.data) {
          if (result.data.hasOwnProperty("priorities")) {
            var priorities = result.data.priorities || [];
            priorities.reverse().forEach(function (unit) {
              self.upperUnit(unit);
            });
            if (!!priorities.length) self.setUnitSort();
          }
        }
      },

      /**
       * 화면에 영향주는 url 파라미터 체크
       */
      checkParams: function () {
        var self = this;

        if (lgkorUI.getParameterByName("unit")) {
          var unitName = lgkorUI.getParameterByName("unit");

          // 스크롤 이동 대신 최상단으로
          self.upperUnit(unitName);
          self.setUnitSort();
        }
      },

      /**
       * 예약 유도 버튼 그룹 배너 활성화 유무 체크
       * @param {string} unitName 유닛명
       */
      checkReserveBanner: function (unitName) {
        var self = this;

        var $plpCont = self.$unitListWrap
          .filter("." + unitName)
          .find("> .result-list");
        var $reserveBanner = $plpCont.nextAll("div[class$='-banner']");
        var plp = $plpCont.data("instance");
        var totalCount = plp.getTotalCount() || 0;
        var listNum = $plpCont.find("> li").length;

        // 매장/상담 배너면 무조건 노출
        // 문제해결 배너면 맨 마지막 페이지에만 노출
        var isShop = $reserveBanner.hasClass("shopservice-banner");
        $reserveBanner.toggle(totalCount <= listNum || isShop);

        // 매장/상담 인 경우
        if (unitName === "shop") {
          // 센터/매장 에서 매장이 0 게이면 "매장 상담 예약" 숨김
          var isServiceCenterAll = !$plpCont.find(".item.shop").not(".center")
            .length;

          $reserveBanner
            .find(".service.advice")
            .parent()
            .toggle(!isServiceCenterAll);
        }
      },

      /**
       * unit 필터 배열로 반환
       * @param {object} data {unit: {검색결과: ["product","support"], ...
       * @returns {array} ["product", "support"]
       */
      getUnitFilterList: function (data) {
        var unit = data.unit || {};
        var unitArr = [];

        for (key in unit) {
          unitArr = unit[key];
        }

        return unitArr;
      },

      /**
       * 필터 데이터 합쳐 반환 ( FilterLayer 의 .create() .select() 인자로 사용 )
       * @return {object} {product:{filterData:{제품타입:["공기청정기"]},smartFilter:{색상:["뉴메탈 샤인","아이언그레이"]}}, ...
       */
      getSumSavedFilterData: function () {
        var self = this;

        // FilterLayer 에서 활용을 위해 유닛명 아래 filterData : {} 로 한번 감쌈
        var filterData = {};
        if (self.savedFilterData) {
          for (unit in self.savedFilterData) {
            var data = $.extend({}, self.savedFilterData[unit]);
            filterData[unit] = { filterData: data };
          }
        }

        // FilterLayer 에서 활용을 위해 유닛명 아래 smartFilter : {} 로 한번 감쌈
        var smartFilter = {};
        if (self.savedSmartFilterData) {
          for (unit in self.savedSmartFilterData) {
            var data = $.extend({}, self.savedSmartFilterData[unit]);
            smartFilter[unit] = { smartFilter: data };
          }
        }

        var filters = $.extend({}, filterData, smartFilter);

        var sumData = {};
        for (key in filters) {
          sumData[key] = $.extend(
            {},
            filterData[key] || {},
            smartFilter[key] || {}
          );
        }

        return sumData;
      },

      /**
       * 모든 정렬 데이터 반환
       * @returns
       */
      getSortValues: function () {
        var self = this;

        var units = [];

        if (self.filterLayer) {
          units =
            self.getUnitFilterList(self.filterLayer.getUnitFilterData()) || [];
        } else {
          self.$unitListWrap.each(function () {
            units.push(this.classList.item(this.classList.length - 1));
          });
        }

        units = units.filter(function (unitName) {
          return unitName !== "new";
        });

        return units.reduce(function (obj, unitName) {
          obj[unitName] = self.$unitListWrap.filter("." + unitName).find(".ui_selectbox").val() || "best";
          return obj;
        }, {});
      },

      /**
       * 내일배송 선택 유무 반환
       */
      getTomorrowChecked: function () {
        var self = this;
        var returnValue = false;

        if (self.savedFilterData) {
          if (
            self.savedFilterData.product &&
            self.savedFilterData.product.hasOwnProperty("producttype")
          ) {
            returnValue =
              self.savedFilterData.product.producttype.indexOf("tomorrow") > -1;
          }
        }

        return returnValue;
      },
      /**
       * 유닛 노출 갯수 반환
       * @param {string} unitName 유닛명
       * @returns
       */
      getUnitLimit: function (unitName) {
        var num = 5;

        switch (unitName) {
          case "product":
            num = 10;
            break;
          case "event":
            num = 3;
            break;
          default:
        }

        return num;
      },

      /**
       * 화면상태 정보 반환
       * @returns
       */
      getUIState: function () {
        var self = this;
        var moreInfo = {};
        var modalInfo = {};

        // 전체보기 싱테
        if (self.moreUnitName) {
          var $listWrap = self.$unitListWrap.filter("." + self.moreUnitName);
          var $plpCont = $listWrap.find("ul.result-list");
          var plp = $plpCont.data("instance");

          if (plp) {
            var plpPageInfo = plp.getPageInfo();

            moreInfo = {
              unit: plp.getUnit(),
              count: plpPageInfo.count,
            };
          }
        }

        // 팝업 상태
        if (self.modalUnitName) {
          var $listWrap = $(
            '.morelist-layer[data-unit="' + self.modalUnitName + '"]'
          );
          var $plpCont = $listWrap.find(".morelist_wrap");
          var plp = $plpCont.data("instance");

          if (plp) {
            var plpPageInfo = plp.getPageInfo();

            modalInfo = {
              scrollY: self.uiState.modal.scrollY || 0,
              unit: plp.getUnit(),
              count: plpPageInfo.count,
              param: plp.getParam(),
            };
          }
        }

        // 필터 영역 상태
        var filterUIState ;
        if(self.filterLayer){
        	filterUIState = self.filterLayer.getUIState();
        }

        // 묶어 반환
        return $.extend({}, self.uiState, filterUIState, {
          more: moreInfo,
          modal: modalInfo,
        });
      },

      /**
       * ajax req 불필요한 데이터 제거
       * @param {object} data
       * @returns
       */
      makePayloadData: function (data) {
        // 스마트 필터 비어있으면 ajax 넘기지 않기 (개발 요청)
        if (data.smartFilter) {
          var smartFilter = JSON.parse(data.smartFilter);
          if (!Object.keys(smartFilter).length) {
            delete data.smartFilter;
          }
        }

        // uiState 제거
        if (data.uiState) {
          delete data.uiState;
        }

        return data;
      },

      /**
       * json 형태 string 필터 데이터 반환
       * @param {*} data
       * @returns
       */
      makeJsonStrFilterData: function (data) {
        var self = this;

        return {
          filterData: JSON.stringify(
            JSON.parse(
              self.makeStrFilterData(JSON.stringify(data.filterData || {}))
            )
          ),
          smartFilter: JSON.stringify(
            JSON.parse(
              self.makeStrFilterData(JSON.stringify(data.smartFilter || {}))
            )
          ),
        };
      },

      /**
       * 필터 string 데이터 세션 저장용으로 변경
       * @param {string} str '{"unit":{"검색결과":["new","product"], ...
       * @returns {string} '{"unit":{"검색결과":"new||product", ...
       */
      makeStrFilterData: function (str) {
        var data = JSON.parse(str || "{}");

        for (key in data) {
          var unit = data[key];

          if ($.isPlainObject(unit)) {
            // 유닛명 있는 경우 (전체 검색에 사용)
            for (key in unit) {
              unit[key] = unit[key].join("||");
            }
          } else {
            // 특정 유닛 검색에 사용
            // {"검색결과":["new","product"] >> {"검색결과":"new||product"
            data[key] = data[key].join("||");
          }
        }

        return JSON.stringify(data);
      },

      /**
       * 필터 string 데이터 배열용으로 변경
       * @param {string} str '{"unit":{"검색결과":"new||product"},"product":{"제품타입":"공기청정기"}}, ...
       * @returns {string} '{"unit":{"검색결과":["new","product"]},"product":{"제품타입":["공기청정기"]}}, ...
       */
      makeArrFilterData: function (str) {
        var data = JSON.parse(str || "{}");

        for (key in data) {
          var unit = data[key];

          for (key in unit) {
            unit[key] = unit[key].split("||");
          }
        }

        return JSON.stringify(data);
      },

      // setter
      /**
       * 필터 데이터 저장
       * @param {object} data {product:{filterData:{제품타입:["공기청정기"]}}, ...
       * @param {object} smart {product:{smartFilter:{색상:["뉴메탈 샤인","아이언그레이"]}}, ...
       */
      setSavedFilterData: function (data, smart) {
        var self = this;

        if (data) {
          if (typeof data === "string") data = JSON.parse(data);

          self.savedFilterData = data;
        }

        if (smart) {
          if (typeof smart === "string") smart = JSON.parse(smart);

          self.savedSmartFilterData = smart;
        }
      },

      /**
       * 검색 정보 세션 스토리지 저장
       * @param {object} data
       */
      setSessionStorage: function (data) {
        var self = this;

        if (self.uniqId) {
          var savedData = lgkorUI.getStorage(self.uniqId);

          if (savedData) {
            lgkorUI.setStorage(self.uniqId, $.extend({}, savedData, data));
          } else {
            lgkorUI.setStorage(self.uniqId, data);
          }
        }
      },

      /**
       * 노출 유닛 리스트 순서 저장
       * @param {boolean} initialize true 시 고객지원 컨텐츠 display 조작 하지 않음 (self.unitSort 초기화용)
       */
      setUnitSort: function (initialize) {
        var self = this;

        var unitName;
        var arr = [];
        self.$unitListWrap.each(function () {
          unitName = $(this).attr("class").split(" ").pop();
          arr.push(unitName);
        });

        self.unitSort = arr;

        if (!initialize) {
          // 문제해결 유닛이 최상단이면 고객지원 컨텐츠 숨김
          self.$customerSupport.toggle(
            self.unitSort.length > 0 && self.unitSort[0] !== "support"
          );
        }
      },

      /**
       * 비교하기 버튼 활성화 변경
       */
      setCompares: function () {
        var self = this;
        var productLI = self.$listProduct // BTOCSITE-49302 [모니터링 G] 제품비교하기 초기화시에도 선택되어 있는것 처럼 노출되는 현상
          .filter(".product")
          .find(".item")
          .closest("li");
        var compareInput = productLI.find(".compare_check input[data-id]");
        compareInput.prop("checked", false);

        var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY);

        for (category in storageCompare) {
          var compareData = storageCompare[category];
          compareData["data"].forEach(function (data) {
            var modelID = data["id"]; // md

            compareInput = productLI.find(
              ".compare_check input[data-id=" + modelID + "]" 
            ); 
            compareInput.prop("checked", true);
          });
        }
      },

			/**
			 * ga
			*/
			setDataLayer: function () {
				if (typeof dataLayer !== "undefined" && dataLayer) {
					dataLayer.push({ event: "searchResultOpen" });
				}
			},

			/**
			 * 내일배송 툴팁
			*/
			srchTooltip: function() {
				var tooltip = $('.srch-tooltip');
				tooltip.each(function() {
					var _t = $(this);
					var btn = _t.children('button');
					var btnClose = _t.children('.tooltip-box').children('.btn-close');
					btn.attr({'aria-haspopup': true, 'aria-expanded': false}).siblings('.tooltip-box').attr({'aria-hidden': true});
					btn.on('click', function(e) {
						e.preventDefault();
						var _b = $(this);
						_b.attr({'aria-expanded': true}).siblings('.tooltip-box').attr({'aria-hidden': false});
						_b.siblings('.tooltip-box').addClass('active');
					});
					
					btnClose.on('click', function(e) {
						e.preventDefault();
						var _close = $(this);
						_close.parent().removeClass('active').attr({'aria-hidden': true});
					});
				});
			},
       
      //검색어 집계 세분화 -> 키워드 히스토리 저장
      //type:1.입력쿼리 > typeDetail:1.검색어입력창
      //type:2.전환쿼리 > typeDetail:1.필터,2.정렬,3.전체보기
      //type:3.클릭쿼리 > typeDetail:1.최근검색어,2.인기검색어,3.연관검색어,4.자동완성,5.대체키워드
      storageKeyword: function ( type, typeDetail ) {

        lgkorUI.setStorage('data-searchkeyword', JSON.stringify({
          type: type,
          typeDetail: typeDetail
        }));
      },
      sendHistoryKeyword: function (query,  totalCount ,tab) {
        var self = this;
        var storedData = lgkorUI.getStorage('data-searchkeyword');
        if (!storedData || Object.keys(storedData).length === 0) { 
          return;
        }
        
        var gaId = lgkorUI.getCookie("_ga") ;
        var parsedData = JSON.parse(storedData);
        var param = {
          
          tab: tab || "all",
          keyword: query,                
          totalCount :   totalCount || 0,
          type: parsedData.type,
          typeDetail: parsedData.typeDetail,
          gaId : gaId,
          serviceName: "B2B" 

        }; 
        lgkorUI.requestKongAjax("searchsvc", "/ajax/v1/search/log-keyword-history-save", {
          method: "POST",                
          contentType: "application/json;charset=UTF-8",
          data: JSON.stringify(param),  // Stringify the param object to send as JSON body
          success: function(result) {
            //성공
          },
          error: function(jqXHR) {
            void 0; 
          },
          complete: function() {
            lgkorUI.removeStorage('data-searchkeyword');
          }
        });
      },
			// 모바일 상단 프로모션 영역 타이틀 높이조절
			promotionBannerHeight: function() {
				var banner = $('.result-banner.mo-only').find('.bnr_area.type02');
				banner.each(function() {
					var _this = $(this);
					if(_this.hasClass('nor') || _this.hasClass('time-deal')) {
						var rightBanner = _this.children('.bnr_right');
						var empty = 26;
						var leftBnHeight = rightBanner.children('a:first-child').find('.bnr_pay').outerHeight() + empty || 0;
						var rightBnHeight = rightBanner.children('a:last-child').find('.bnr_pay').outerHeight() + empty || 0;
						var maxHeight;
						if(leftBnHeight < rightBnHeight) {
							maxHeight = rightBnHeight
						} else {
							maxHeight = leftBnHeight;
						}
						rightBanner.css({height: maxHeight});
					}
				});
			}
		
		};
		search.init();
		
	});

	// 뒤로가기시 isIOS 스크립트 호출 안되는경우 처리
	$(window).on('pageshow',function(e){  
		if(e.originalEvent ){
			if(  e.originalEvent.persisted && vcui.detect.isIOS) {
				search.init();
			}
		}
	});

	// 검색 스크롤 이벤트
	$(window).on('scroll',function(){
		var _this = $(this);
		var winW = _this.width();
		var mobW = 767;
		var nowScr = _this.scrollTop();
		var nafilterChoice = $('.nafilter_choice');
		var nafilterChoiceOffsetT = parseInt(nafilterChoice.offset().top);
		var nafilterChoiceTop = parseInt(nafilterChoice.css('top'));
		var keywordWrap = $('.contents.search').children('.input-keyword-wrap');
		var keywordOffsetT = parseInt(keywordWrap.offset().top);
		var contWrap = $('.cont-wrap');
		var filterWrap = $('#filterWrap');
		var footerHeight = $('footer').outerHeight();

	    var scTop = $(document).scrollTop(); 
	    var closeAllviewBtn = $('.result-allview.fixed'); // 전체보기닫기 버튼
	    var resultListSections = closeAllviewBtn.parent().parent('.list-wrap'); // 리스트 영역

		if (winW > mobW) {
			if (nowScr >= keywordOffsetT) {
				keywordWrap.addClass('scroll');
				_this.scrollTop(nowScr);
			} else {
				keywordWrap.removeClass('scroll');
			}
			
			if(nowScr >= contWrap.offset().top - keywordWrap.outerHeight()) {
				contWrap.addClass('fixed');
			} else {
				contWrap.removeClass('fixed');
			}
			
			if(nowScr >= $(document).height() - _this.height() - footerHeight) {
				contWrap.addClass('btm');
			} else {
				contWrap.removeClass('btm');
			}

		} else {
			if (nowScr == 0) {
				keywordWrap.removeClass('scroll');
			} else {
				keywordWrap.addClass('scroll');
			}
		}

		if(nowScr + nafilterChoiceTop >= nafilterChoiceOffsetT) {
			nafilterChoice.addClass('scroll_sticky');
		} else {
			nafilterChoice.removeClass('scroll_sticky');
		}
		
	    for(var i = 0; i < resultListSections.length; i++){

	        var resultListTop = resultListSections.eq(i).offset().top; // 리스트 영역의 상단 위치
	        var resultListHeight = closeAllviewBtn.eq(i).parent().parent('.list-wrap').outerHeight(); // 리스트 영역의 높이 
	        var resultListBottom = resultListTop+resultListHeight;  //리스트 영역의 하단 위치

	        if(scTop < resultListTop) {
	          closeAllviewBtn.eq(i).addClass("outside");
	        }else if(scTop > resultListBottom){
	          closeAllviewBtn.eq(i).addClass("outside");
	        }else{
	          closeAllviewBtn.eq(i).removeClass("outside");
	        }
	    }

      //BTOCSITE-66656
      var nafilterTabs =  $('.nafilter_tabs');
      if(window.innerWidth < 768){
        //console.log(nafilterChoice.offset().top - nafilterTabs.offset().top)
        if( nafilterChoice.offset().top - nafilterTabs.offset().top <= 56){
          nafilterChoice.css('opacity','0').css('z-index','-10')
          nafilterTabs.css('opacity','0').css('z-index','-10')
        }else{
          nafilterChoice.css('opacity','1').css('z-index','91')
          nafilterTabs.css('opacity','1').css('z-index','91')
        }   
      }else{
        nafilterChoice.css('opacity','1').css('z-index','91')
        nafilterTabs.css('opacity','1').css('z-index','91')
      }
      ////BTOCSITE-66656   
	});
})();

/********************************************************************************************
 ************************************** ScrollStatus ***************************************
 ********************************************************************************************/
/**
 * var instance = new ScrollStatus();
 * instance.init(options);           //초기화
 *
 * @param options    ::: 설정 Object 값
 *
 * options
 *   namespace:String = ''           //scroll 이벤트 중복 방지를 위한 네임스페이스 'scroll.scrollstatus' + namespace
 *   resistance:Boolean = true       //저항(ios) 체크 유무 설정 (PC에서 true 설정 시 화면 최상단일때 더이상 스크롤에 반응안함)
 *   topThreshold:Number = 2         //ios 아래서 위로 올릴때 소프키 등장으로 처음 한계를 0 이 아닌 높이 지정
 *   frameRate:Number = 36           //timer 속도
 *   initUpdate:Boolean = false      //처음 window.load 시 체크 할지 유무
 *   exChange:Function = fun(data)   //변경시 발생될 함수
 *
 * method
 *   .update()                       //스크롤 이벤트를 타지않는 상태에서 수동 체크 함수
 *
 */
//prettier-ignore
var ScrollStatus=function(e){return function(n){var t,o,s,c,a,r,l,i,u,d,m={namespace:"",resistance:!0,topThreshold:2,frameRate:36,initUpdate:!1,exChange:void 0},p=function(){d.initUpdate&&(a=0,t.update()),e(window).on("resize.scrollstatus"+d.namespace,function(e){i=window.innerHeight}).triggerHandler("resize.scrollstatus"+d.namespace),e(window).on("scroll.scrollstatus"+d.namespace,function(e){u&&g()}).triggerHandler("scroll.scrollstatus"+d.namespace),e("html, body").on("touchstart.scrollstatus"+d.namespace,function(e){u=!1,h(),c=setInterval(f,1e3/d.frameRate)}),e("html, body").on("touchend.scrollstatus"+d.namespace,function(e){u=!0,h()})};function h(){void 0!==c&&clearInterval(c)}function f(){g()}function g(){r=0!==document.documentElement.scrollTop?document.documentElement.scrollTop:document.body.scrollTop,l=e("html").get(0).scrollHeight-i,r<=d.topThreshold&&d.resistance?(u=!1,o="up",s=0):r>=l&&d.resistance?(u=!1,o="down",s=0):(o=(s=a-r)>0?"up":s<0?"down":void 0,a=r),void 0!==d.exChange&&d.exChange({distance:s,direct:o,scrolling:u})}return{init:function(n){d=e.extend({},m,n),t=this,p()},update:function(){g()}}}}(jQuery);

